import React, { useState, useEffect, useRef } from "react";
import {
  Video,
  VideoOff,
  Mic,
  MicOff,
  Phone,
  Users,
  MessageCircle,
  Settings,
  Share2,
  MoreVertical,
  ChevronLeft,
  Moon,
  Sun,
  Crown,
  Shield,
  Volume2,
  VolumeX,
  Camera,
  CameraOff,
  ScreenShare,
  Send,
  Copy,
  Grid,
  Layout,
  AppWindow,
  Presentation,
  User,
  Hand,
  Bell,
  Monitor,
  Maximize2,
  Minimize2,
  MoreHorizontal,
  Clock,
  Wifi,
  WifiOff,
  Battery,
  BatteryCharging,
  Volume1,
  VolumeX as VolumeXIcon,
  Eye,
  EyeOff,
  Lock,
  Unlock,
  Flag,
  AlertCircle,
  CheckCircle,
  XCircle,
  Play,
  Pause,
  CircleDot,
  Circle,
  Triangle,
  Star,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Coffee,
  Phone as PhoneIcon,
  Video as VideoIcon,
  Mic as MicIcon,
  Settings as SettingsIcon,
  HelpCircle,
  Info,
  Zap,
  Sliders,
  Sparkles,
  Pin,
  X,
  RefreshCw,
  UserPlus,
  ChevronRight,
  ChevronUp,
  BarChart2,
  ArrowDown,
  ArrowUp,
  ChevronDown,
  Trash2,
  Plus,
  Edit2,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import Dropdown from "../components/Dropdown";
import ToggleSwitch from "../components/ToggleSwitch";
import { useTheme } from "../contexts/ThemeContext";
import { useAuth } from "../contexts/AuthContext";


const participants = [
  {
    id: 1,
    name: "Alex Johnson",
    role: "Host",
    isHost: true,
    isSpeaking: true,
    isMuted: false,
    isVideoOn: true,
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    status: "online",
    connection: "excellent",
    handRaised: false,
    spotlighted: false,
    pinned: false,
  },
  {
    id: 2,
    name: "Sarah Chen",
    role: "Co-host",
    isHost: false,
    isSpeaking: false,
    isMuted: true,
    isVideoOn: true,
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    status: "online",
    connection: "good",
    handRaised: true,
    spotlighted: false,
    pinned: false,
  },
  {
    id: 3,
    name: "Mike Davis",
    role: "Participant",
    isHost: false,
    isSpeaking: false,
    isMuted: false,
    isVideoOn: false,
    avatar: "https://randomuser.me/api/portraits/men/45.jpg",
    status: "online",
    connection: "poor",
    handRaised: false,
    spotlighted: false,
    pinned: false,
  },
  {
    id: 4,
    name: "Emily Brown",
    role: "Participant",
    isHost: false,
    isSpeaking: false,
    isMuted: true,
    isVideoOn: true,
    avatar: "https://randomuser.me/api/portraits/women/46.jpg",
    status: "online",
    connection: "excellent",
    handRaised: false,
    spotlighted: false,
    pinned: false,
  },
  {
    id: 5,
    name: "David Wilson",
    role: "Participant",
    isHost: false,
    isSpeaking: false,
    isMuted: false,
    isVideoOn: true,
    avatar: "https://randomuser.me/api/portraits/men/47.jpg",
    status: "online",
    connection: "good",
    handRaised: false,
    spotlighted: false,
    pinned: false,
  },
  {
    id: 6,
    name: "Lisa Rodriguez",
    role: "Participant",
    isHost: false,
    isSpeaking: false,
    isMuted: false,
    isVideoOn: true,
    avatar: "https://randomuser.me/api/portraits/women/48.jpg",
    status: "online",
    connection: "excellent",
    handRaised: false,
    spotlighted: false,
    pinned: false,
  },
  {
    id: 7,
    name: "James Thompson",
    role: "Participant",
    isHost: false,
    isSpeaking: false,
    isMuted: true,
    isVideoOn: false,
    avatar: "https://randomuser.me/api/portraits/men/49.jpg",
    status: "online",
    connection: "good",
    handRaised: false,
    spotlighted: false,
    pinned: false,
  },
  {
    id: 8,
    name: "Maria Garcia",
    role: "Participant",
    isHost: false,
    isSpeaking: false,
    isMuted: false,
    isVideoOn: true,
    avatar: "https://randomuser.me/api/portraits/women/50.jpg",
    status: "online",
    connection: "excellent",
    handRaised: false,
    spotlighted: false,
    pinned: false,
  },
];

// Mock waiting room participants
const waitingRoomParticipants = [
  {
    id: 101,
    name: "Alice Johnson",
    avatar: "https://randomuser.me/api/portraits/women/32.jpg",
    waitTime: "2:30",
    email: "alice.johnson@company.com",
  },
  {
    id: 102,
    name: "Bob Smith",
    avatar: "https://randomuser.me/api/portraits/men/45.jpg",
    waitTime: "1:15",
    email: "bob.smith@company.com",
  },
  {
    id: 103,
    name: "Carol Davis",
    avatar: "https://randomuser.me/api/portraits/women/68.jpg",
    waitTime: "0:45",
    email: "carol.davis@company.com",
  },
];

const initialNotifications = [
  {
    id: 1,
    icon: <CheckCircle className="text-blue-400" size={18} />,
    text: "Team Standup meeting starts in 15 minutes",
  },
  {
    id: 2,
    icon: <Video className="text-green-400" size={18} />,
    text: 'Sarah invited you to join "Q4 Planning Session"',
  },
  {
    id: 3,
    icon: <Users className="text-purple-400" size={18} />,
    text: "3 participants joined your meeting room",
  },
  {
    id: 4,
    icon: <AlertCircle className="text-red-400" size={18} />,
    text: "Your account password expires in 7 days",
  },
];

const chatMessages = [
  {
    id: 1,
    sender: "Alex Johnson",
    message: "Welcome everyone to our Q1 planning meeting! 🎯",
    time: "2:30 PM",
    isOwn: false,
    type: "text",
  },
  {
    id: 2,
    sender: "You",
    message: "Thanks Alex, excited to be here!",
    time: "2:31 PM",
    isOwn: true,
    type: "text",
  },
  {
    id: 3,
    sender: "Sarah Chen",
    message: "Great to see everyone. Should we start with the agenda?",
    time: "2:31 PM",
    isOwn: false,
    type: "text",
  },
  {
    id: 4,
    sender: "Mike Davis",
    message: "Perfect timing. I have some updates to share.",
    time: "2:32 PM",
    isOwn: false,
    type: "text",
  },
  {
    id: 5,
    sender: "System",
    message: "Sarah Chen raised their hand",
    time: "2:33 PM",
    isOwn: false,
    type: "system",
  },
  {
    id: 6,
    sender: "Emily Brown",
    message: "Can someone share their screen for the presentation?",
    time: "2:34 PM",
    isOwn: false,
    type: "text",
  },
  {
    id: 7,
    sender: "Alex Johnson",
    message: "Sure, I'll share the Q1 roadmap now",
    time: "2:35 PM",
    isOwn: false,
    type: "text",
  },
  {
    id: 8,
    sender: "System",
    message: "Alex Johnson started screen sharing",
    time: "2:35 PM",
    isOwn: false,
    type: "system",
  },
];

const MeetingNew: React.FC = () => {
  const navigate = useNavigate();
  const chatEndRef = useRef<HTMLDivElement>(null);
  const mainContentRef = useRef<HTMLDivElement>(null);
  const [mainTopOffset, setMainTopOffset] = useState(0);
  const leftActiveRef = useRef<HTMLDivElement>(null);
  const [sidePanelTopPad, setSidePanelTopPad] = useState(0);
  // const [darkMode, setDarkMode] = useState(false);
  const {darkMode, toggleDarkMode} = useTheme();
  const [isMuted, setIsMuted] = useState(false);
  const [isVideoOn, setIsVideoOn] = useState(true);
  const [isScreenSharing, setIsScreenSharing] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [captionsEnabled, setCaptionsEnabled] = useState(false);
  const [showParticipants, setShowParticipants] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showReactions, setShowReactions] = useState(false);
  const [chatMessage, setChatMessage] = useState("");
  const [chatTab, setChatTab] = useState<"Chat" | "Polls">("Chat");
  const [participantsTab, setParticipantsTab] = useState<
    "Meeting" | "Waiting room"
  >("Meeting");
  const [currentTime, setCurrentTime] = useState("");
  const [meetingDuration, setMeetingDuration] = useState(0);
  const [layout, setLayout] = useState<
    "grid" | "spotlight" | "sidebar" | "gallery"
  >("grid");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showHandRaise, setShowHandRaise] = useState(false);
  const [connectionQuality, setConnectionQuality] = useState("excellent");
  const [batteryLevel, setBatteryLevel] = useState(85);
  const [isCharging, setIsCharging] = useState(false);
  const [activeSpeaker, setActiveSpeaker] = useState(1);
  const [pinnedParticipant, setPinnedParticipant] = useState<number | null>(
    null
  );
  const [spotlightedParticipant, setSpotlightedParticipant] = useState<
    number | null
  >(null);
  const [showConnectionInfo, setShowConnectionInfo] = useState(false);
  const [meetingTitle, setMeetingTitle] = useState("Q1 Planning Meeting");
  const [meetingId, setMeetingId] = useState(
    `VELA-${Math.random().toString(36).substr(2, 8).toUpperCase()}`
  );
  const [notifications, setNotifications] = useState(initialNotifications);
  const [clearedNotifications, setClearedNotifications] = useState<any[]>([]);
  const [showNotificationsModal, setShowNotificationsModal] = useState(false);
  const [notificationsTab, setNotificationsTab] = useState<
    "current" | "cleared"
  >("current");
  const [showMoreDropdown, setShowMoreDropdown] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showBandwidthModal, setShowBandwidthModal] = useState(false);
  const [bandwidthLevel, setBandwidthLevel] = useState(3);
  const [showParticipantStatsModal, setShowParticipantStatsModal] =
    useState(false);
  const [participantSearch, setParticipantSearch] = useState("");
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [settingsTab, setSettingsTab] = useState<
    "Audio" | "Video" | "Notifications" | "Profile" | "Shortcuts" | "General"
  >("Audio");
  const [currentPage, setCurrentPage] = useState(0);
  const [showMicDropdown, setShowMicDropdown] = useState(false);
  const [selectedMicrophone, setSelectedMicrophone] =
    useState("Default Microphone");
  const [selectedSpeaker, setSelectedSpeaker] = useState("Default Speaker");
  const [showCameraDropdown, setShowCameraDropdown] = useState(false);
  const [selectedCamera, setSelectedCamera] = useState("Default Camera");
  const [showScreenShareDropdown, setShowScreenShareDropdown] = useState(false);
  const [enableNoiseSuppression, setEnableNoiseSuppression] = useState(true);
  const [mirrorVideo, setMirrorVideo] = useState(true);
  const [participantMenuOpenId, setParticipantMenuOpenId] = useState<
    number | null
  >(null);
  const [participantsDropdownMenuOpenId, setParticipantsDropdownMenuOpenId] =
    useState<number | null>(null);
  const [participantVolumeById, setParticipantVolumeById] = useState<
    Record<number, number>
  >({});
  const [participantConnectionOpenId, setParticipantConnectionOpenId] =
    useState<number | null>(null);
  const [
    participantConnectionExpandedById,
    setParticipantConnectionExpandedById,
  ] = useState<Record<number, boolean>>({});
  const [sidePanelPage, setSidePanelPage] = useState(0);
  const {user, logout} = useAuth();
  const [waitingParticipants, setWaitingParticipants] = useState(
    waitingRoomParticipants
  );
  const [cameraBarCollapsed, setCameraBarCollapsed] = useState(false);
  const [showWhiteboard, setShowWhiteboard] = useState(false);
  const [showShareVideoModal, setShowShareVideoModal] = useState(false);
  const [shareVideoUrl, setShareVideoUrl] = useState("");
  const [showBreakoutRoomsModal, setShowBreakoutRoomsModal] = useState(false);
  const [breakoutRooms, setBreakoutRooms] = useState<
    Array<{ id: number; name: string; participantIds: number[] }>
  >([
    { id: 1, name: "Room 1", participantIds: [] },
    { id: 2, name: "Room 2", participantIds: [] },
  ]);
  const [selectedBreakoutRoomId, setSelectedBreakoutRoomId] = useState<
    number | null
  >(1);
  const assignedParticipantIds = (() => {
    const set = new Set<number>();
    breakoutRooms.forEach((r) => r.participantIds.forEach((id) => set.add(id)));
    return set;
  })();
  const selectedBreakoutRoom =
    breakoutRooms.find((r) => r.id === selectedBreakoutRoomId) || null;
  const [breakoutRoomsOpen, setBreakoutRoomsOpen] = useState(false);
  const canToggleBreakoutRooms =
    breakoutRoomsOpen ||
    (breakoutRooms.length > 0 &&
      breakoutRooms.some((r) => r.participantIds.length > 0));
  const [myBreakoutRoomId, setMyBreakoutRoomId] = useState<number | null>(null);
  const canJoinSelectedRoom =
    breakoutRoomsOpen && selectedBreakoutRoomId !== null;
  const [editingRoomId, setEditingRoomId] = useState<number | null>(null);
  const [editingRoomName, setEditingRoomName] = useState("");

  // Sample poll state and voting
  const [poll, setPoll] = useState({
    id: "sample-1",
    question: "Which feature should we focus on next?",
    options: [
      { text: "Performance", votes: 4 },
      { text: "New UI", votes: 3 },
      { text: "Mobile App", votes: 5 },
    ],
    totalVotes: 12,
  });
  const [pollVote, setPollVote] = useState<number | null>(null);

  const [showCaptionsModal, setShowCaptionsModal] = useState(false);
  const [captionMode, setCaptionMode] = useState<"closed" | "translated">(
    "closed"
  );
  const [sourceLanguage, setSourceLanguage] = useState("English");
  const [targetLanguage, setTargetLanguage] = useState("Spanish");

  const handlePollVote = (optionIndex: number) => {
    if (pollVote !== null) return; // prevent multiple votes
    setPoll((prev) => {
      const updatedOptions = prev.options.map((opt, idx) =>
        idx === optionIndex ? { ...opt, votes: opt.votes + 1 } : opt
      );
      return {
        ...prev,
        options: updatedOptions,
        totalVotes: prev.totalVotes + 1,
      };
    });
    setPollVote(optionIndex);
  };

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setCurrentTime(
        now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      );
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const updateMeetingDuration = () => {
      setMeetingDuration((prev) => prev + 1);
    };
    const interval = setInterval(updateMeetingDuration, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const updateActiveSpeaker = () => {
      const speakingParticipants = participants.filter((p) => p.isSpeaking);
      if (speakingParticipants.length > 0) {
        const randomSpeaker =
          speakingParticipants[
            Math.floor(Math.random() * speakingParticipants.length)
          ];
        setActiveSpeaker(randomSpeaker.id);
      }
    };
    const interval = setInterval(updateActiveSpeaker, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatMessages]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      const inMic = !!target.closest(".mic-dropdown-container");
      const inCam = !!target.closest(".camera-dropdown-container");
      if (showMicDropdown && !inMic) setShowMicDropdown(false);
      if (showCameraDropdown && !inCam) setShowCameraDropdown(false);
      if (
        participantMenuOpenId !== null &&
        !target.closest(".participant-more-container")
      ) {
        setParticipantMenuOpenId(null);
      }
      if (
        participantsDropdownMenuOpenId !== null &&
        !target.closest(".participants-dropdown-more-container")
      ) {
        setParticipantsDropdownMenuOpenId(null);
      }
      if (
        participantConnectionOpenId !== null &&
        !target.closest(".participant-connection-container")
      ) {
        setParticipantConnectionOpenId(null);
      }
    };

    if (
      showMicDropdown ||
      showCameraDropdown ||
      participantMenuOpenId !== null ||
      participantsDropdownMenuOpenId !== null ||
      participantConnectionOpenId !== null
    ) {
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [
    showMicDropdown,
    showCameraDropdown,
    participantMenuOpenId,
    participantsDropdownMenuOpenId,
    participantConnectionOpenId,
  ]);

  // Close reactions dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      const inReactions = !!target.closest(".reactions-dropdown-container");
      if (showReactions && !inReactions) setShowReactions(false);
    };

    if (showReactions) {
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [showReactions]);

  // Close more dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      const inMore = !!target.closest(".more-dropdown-container");
      const inChat = !!target.closest(".chat-dropdown-container");
      const inParticipants = !!target.closest(
        ".participants-dropdown-container"
      );
      if (showMoreDropdown && !inMore) setShowMoreDropdown(false);
      if (showChat && !inChat) setShowChat(false);
      if (showParticipants && !inParticipants) setShowParticipants(false);
      // remove standalone waiting room close; handled by participants dropdown
    };

    if (showMoreDropdown || showChat || showParticipants) {
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [showMoreDropdown, showChat, showParticipants]);

  const formatDuration = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const handleSendMessage = () => {
    if (chatMessage.trim()) {
      // Add message logic here
      setChatMessage("");
    }
  };

  const handleLeaveMeeting = () => {
    if (window.confirm("Are you sure you want to leave the meeting?")) {
      navigate("/");
    }
  };

  const handleToggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  const handleToggleHandRaise = () => {
    setShowHandRaise(!showHandRaise);
  };

  const handlePinParticipant = (participantId: number) => {
    setPinnedParticipant(
      pinnedParticipant === participantId ? null : participantId
    );
  };

  const handleSpotlightParticipant = (participantId: number) => {
    setSpotlightedParticipant(
      spotlightedParticipant === participantId ? null : participantId
    );
  };

  const getConnectionColor = (quality: string) => {
    switch (quality) {
      case "excellent":
        return "text-green-500";
      case "good":
        return "text-yellow-500";
      case "poor":
        return "text-red-500";
      default:
        return "text-gray-500";
    }
  };

  const getConnectionIcon = (quality: string, size: number = 16) => {
    switch (quality) {
      case "excellent":
        return <Wifi size={size} className="text-green-500" />;
      case "good":
        return <Wifi size={size} className="text-yellow-500" />;
      case "poor":
        return <WifiOff size={size} className="text-red-500" />;
      default:
        return <Wifi size={size} className="text-gray-500" />;
    }
  };

  const handleClearNotification = (id: number) => {
    const notif = notifications.find((n) => n.id === id);
    if (notif) {
      setNotifications(notifications.filter((n) => n.id !== id));
      setClearedNotifications([notif, ...clearedNotifications]);
    }
  };

  const handleClearAll = () => {
    setClearedNotifications([...notifications, ...clearedNotifications]);
    setNotifications([]);
  };

  const handleRestoreNotification = (id: number) => {
    const notif = clearedNotifications.find((n) => n.id === id);
    if (notif) {
      setClearedNotifications(clearedNotifications.filter((n) => n.id !== id));
      setNotifications([notif, ...notifications]);
    }
  };

  const handleAdmitParticipant = (participantId: number) => {
    setWaitingParticipants((prev) =>
      prev.filter((p) => p.id !== participantId)
    );
    // In a real app, this would send a WebSocket message to admit the participant
    console.log(`Admitting participant ${participantId}`);
  };

  const handleDenyParticipant = (participantId: number) => {
    setWaitingParticipants((prev) =>
      prev.filter((p) => p.id !== participantId)
    );
    // In a real app, this would send a WebSocket message to deny the participant
    console.log(`Denying participant ${participantId}`);
  };

  const handleAdmitAll = () => {
    setWaitingParticipants([]);
    // In a real app, this would send WebSocket messages to admit all waiting participants
    console.log("Admitting all waiting participants");
  };

  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Toggle camera bar with 'B' key (only in spotlight mode)
      if (event.key === "b" || event.key === "B") {
        if (layout === "spotlight") {
          event.preventDefault();
          setCameraBarCollapsed(!cameraBarCollapsed);
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [layout, cameraBarCollapsed]);

  const handlePreviousPage = () => {
    setCurrentPage((prev) => Math.max(0, prev - 1));
  };

  const handleNextPage = () => {
    const maxPage = Math.ceil(participants.length / 6) - 1;
    setCurrentPage((prev) => Math.min(maxPage, prev + 1));
  };

  const getVisibleParticipants = () => {
    const startIndex = currentPage * 6;
    return participants.slice(startIndex, startIndex + 6);
  };

  const mockAudioDevices = {
    microphones: [
      { id: "mic1", name: "Default Microphone", isActive: true },
      { id: "mic2", name: "USB Microphone", isActive: false },
      { id: "mic3", name: "Built-in Microphone", isActive: false },
      { id: "mic4", name: "Bluetooth Headset Mic", isActive: false },
    ],
    speakers: [
      { id: "spk1", name: "Default Speaker", isActive: true },
      { id: "spk2", name: "USB Headphones", isActive: false },
      { id: "spk3", name: "Built-in Speakers", isActive: false },
      { id: "spk4", name: "Bluetooth Headset", isActive: false },
    ],
    cameras: [
      { id: "cam1", name: "Default Camera", isActive: true },
      { id: "cam2", name: "HD USB Camera", isActive: false },
      { id: "cam3", name: "Built-in Camera", isActive: false },
      { id: "cam4", name: "Virtual Camera", isActive: false },
    ],
  };

  const handleCameraSelect = (cameraName: string) => {
    setSelectedCamera(cameraName);
  };

  const handleMicrophoneSelect = (micName: string) => {
    setSelectedMicrophone(micName);
  };

  const handleSpeakerSelect = (speakerName: string) => {
    setSelectedSpeaker(speakerName);
  };

  useEffect(() => {
    const updateOffsets = () => {
      const top = mainContentRef.current?.getBoundingClientRect().top ?? 0;
      setMainTopOffset(top);
      const leftTop = leftActiveRef.current?.getBoundingClientRect().top ?? top;
      const pad = Math.max(0, leftTop - top);
      setSidePanelTopPad(pad);
    };
    updateOffsets();
    window.addEventListener("resize", updateOffsets);
    window.addEventListener("scroll", updateOffsets, { passive: true } as any);
    return () => {
      window.removeEventListener("resize", updateOffsets);
      window.removeEventListener("scroll", updateOffsets as any);
    };
  }, []);

  // Close screen share dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      const inScreenShare = !!target.closest(".screenshare-dropdown-container");
      if (showScreenShareDropdown && !inScreenShare)
        setShowScreenShareDropdown(false);
    };

    if (showScreenShareDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [showScreenShareDropdown]);

  const handleCreateBreakoutRoom = () => {
    setBreakoutRooms((prevRooms) => [
      ...prevRooms,
      {
        id: Date.now(),
        name: `Room ${prevRooms.length + 1}`,
        participantIds: [],
      },
    ]);
  };

  const handleDeleteBreakoutRoom = (roomId: number) => {
    setBreakoutRooms((prevRooms) => {
      const updated = prevRooms.filter((r) => r.id !== roomId);
      if (selectedBreakoutRoomId === roomId) {
        setSelectedBreakoutRoomId(updated.length ? updated[0].id : null);
      }
      return updated;
    });
  };

  const handleSelectBreakoutRoom = (roomId: number) => {
    setSelectedBreakoutRoomId(roomId);
  };

  const handleAssignToSelectedRoom = (participantId: number) => {
    if (!selectedBreakoutRoomId) return;
    setBreakoutRooms((prevRooms) =>
      prevRooms.map((room) => {
        if (room.id === selectedBreakoutRoomId) {
          const next = new Set(room.participantIds);
          next.add(participantId);
          return { ...room, participantIds: Array.from(next) };
        }
        return {
          ...room,
          participantIds: room.participantIds.filter(
            (id) => id !== participantId
          ),
        };
      })
    );
  };

  const handleRemoveFromRoom = (roomId: number, participantId: number) => {
    setBreakoutRooms((prevRooms) =>
      prevRooms.map((room) =>
        room.id === roomId
          ? {
              ...room,
              participantIds: room.participantIds.filter(
                (id) => id !== participantId
              ),
            }
          : room
      )
    );
  };

  const handleToggleBreakoutRooms = () => {
    setBreakoutRoomsOpen((prev) => !prev);
  };

  const handleJoinSelectedBreakoutRoom = () => {
    if (!selectedBreakoutRoomId || !breakoutRoomsOpen) return;
    setMyBreakoutRoomId(selectedBreakoutRoomId);
    setShowBreakoutRoomsModal(false);
  };

  const startEditRoomName = (roomId: number, currentName: string) => {
    setEditingRoomId(roomId);
    setEditingRoomName(currentName);
  };

  const cancelEditRoomName = () => {
    setEditingRoomId(null);
    setEditingRoomName("");
  };

  const saveEditRoomName = () => {
    if (!editingRoomId) return;
    const name = editingRoomName.trim();
    if (!name) return cancelEditRoomName();
    setBreakoutRooms((prev) =>
      prev.map((r) => (r.id === editingRoomId ? { ...r, name } : r))
    );
    setEditingRoomId(null);
    setEditingRoomName("");
  };

  return (
    <div
      className={`min-h-screen ${
        darkMode
          ? "bg-gradient-to-br from-[#0a0a1a] to-[#1a1a2e] text-white"
          : "bg-gradient-to-br from-gray-50 to-blue-50 text-gray-900"
      }`}
    >
      {/* Top Status Bar */}
      <div
        className={`sticky top-0 z-50 ${
          darkMode ? "bg-black/20" : "bg-white/20"
        } backdrop-blur-xl border-b ${
          darkMode ? "border-white/10" : "border-gray-200/50"
        }`}
      >
        <div className="flex items-center justify-between px-6 py-3">
          {/* Meeting Info */}
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-3">
              <div>
                <h1
                  className={`text-lg font-bold ${
                    darkMode ? "text-white" : "text-gray-900"
                  }`}
                >
                  {meetingTitle}
                </h1>
                <div className="flex items-center gap-4 text-sm">
                  <span
                    className={`${
                      darkMode ? "text-white/60" : "text-gray-600"
                    }`}
                  >
                    Duration: {formatDuration(meetingDuration)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Status Indicators */}
          <div className="flex items-center gap-6">
            <button
              className={`p-2 rounded-lg transition-all duration-200 group ${
                darkMode ? "hover:bg-white/10" : "hover:bg-gray-200"
              }`}
              onClick={toggleDarkMode}
            >
              {darkMode ? (
                <Sun
                  className="text-white/70 group-hover:text-white"
                  size={22}
                />
              ) : (
                <Moon
                  className="text-gray-600 group-hover:text-gray-800"
                  size={22}
                />
              )}
            </button>
            <Dropdown
              trigger={
                <button
                  className={`relative p-2 rounded-lg transition-all duration-200 group ${
                    darkMode ? "hover:bg-white/10" : "hover:bg-gray-200"
                  }`}
                >
                  <Bell
                    className={`${
                      darkMode
                        ? "text-white/70 group-hover:text-white"
                        : "text-gray-600 group-hover:text-gray-800"
                    }`}
                    size={22}
                  />
                  {notifications.length > 0 && (
                    <span className="absolute -top-1 -right-1 w-3 h-3 bg-gradient-to-r from-red-500 to-pink-500 rounded-full border-2 border-white"></span>
                  )}
                </button>
              }
              align="right"
              darkMode={darkMode}
            >
              <div
                className={`w-96 rounded-xl shadow-2xl border p-4 ${
                  darkMode
                    ? "bg-[#232336] border-white/10"
                    : "bg-white border-gray-200"
                }`}
              >
                {/* Header */}
                <div className="flex items-center justify-between mb-4 pl-3">
                  <div className="flex items-center gap-2">
                    <h3
                      className={`text-lg font-bold ${
                        darkMode ? "text-white" : "text-gray-900"
                      }`}
                    >
                      Notifications
                    </h3>
                  </div>
                  {notifications.length > 0 && (
                    <span className="px-2 py-1 bg-green-600/20 text-green-600 text-xs rounded-full font-medium">
                      {notifications.length} new
                    </span>
                  )}
                </div>

                {/* Notifications List */}
                <div className="max-h-64 overflow-y-auto scrollbar-hide">
                  {notifications.length === 0 ? (
                    <div className="text-center py-8">
                      <div
                        className={`w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full ${
                          darkMode ? "bg-white/5" : "bg-gray-100"
                        }`}
                      >
                        <Bell
                          size={20}
                          className={`${
                            darkMode ? "text-white/40" : "text-gray-400"
                          }`}
                        />
                      </div>
                      <p
                        className={`text-sm ${
                          darkMode ? "text-white/60" : "text-gray-600"
                        }`}
                      >
                        No notifications
                      </p>
                      <p
                        className={`text-xs mt-1 ${
                          darkMode ? "text-white/40" : "text-gray-500"
                        }`}
                      >
                        You're all caught up!
                      </p>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {notifications.slice(0, 4).map((n) => (
                        <div
                          key={n.id}
                          className={`group p-3 rounded-lg border transition-all duration-200 cursor-pointer ${
                            darkMode
                              ? "bg-white/5 border-white/10 hover:bg-white/10 hover:border-white/20"
                              : "bg-gray-50 border-gray-200 hover:bg-gray-100 hover:border-gray-300"
                          }`}
                        >
                          <div className="flex items-start gap-3">
                            <div className="flex-shrink-0 mt-0.5">{n.icon}</div>
                            <div className="flex-1 min-w-0">
                              <p
                                className={`text-sm leading-relaxed ${
                                  darkMode ? "text-white/90" : "text-gray-900"
                                }`}
                              >
                                {n.text}
                              </p>
                              <p
                                className={`text-xs mt-1 ${
                                  darkMode ? "text-white/40" : "text-gray-500"
                                }`}
                              >
                                Just now
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Footer */}
                {notifications.length > 0 && (
                  <div
                    className={`mt-4 pt-3 border-t ${
                      darkMode ? "border-white/10" : "border-gray-200"
                    }`}
                  >
                    <button
                      className="w-full text-center text-sm font-medium py-2 px-4 rounded-lg bg-gradient-to-r from-red-600 to-pink-600 hover:scale-105 text-white transition-all duration-200 shadow-lg"
                      onClick={() => setShowNotificationsModal(true)}
                    >
                      View all notifications
                    </button>
                  </div>
                )}
              </div>
            </Dropdown>
            <Dropdown
              trigger={
                <div
                  className={`flex items-center gap-2 sm:gap-3 p-1.5 sm:p-2 rounded-xl cursor-pointer transition-all duration-200 ${
                    darkMode ? "hover:bg-white/10" : "hover:bg-gray-100"
                  }`}
                >
                  <img
                    src="https://randomuser.me/api/portraits/women/44.jpg"
                    alt="profile"
                    className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-white/20 flex-shrink-0"
                  />
                  <div className="hidden sm:block text-left min-w-0 flex-1">
                    <div
                      className={`text-xs sm:text-sm font-medium truncate ${
                        darkMode ? "text-white" : "text-gray-900"
                      }`}
                    >
                      {user ? user?.first_name + " " + user?.last_name : "Guest User"} 
                    </div>
                    <div
                      className={`text-xs ${
                        darkMode ? "text-white/60" : "text-gray-500"
                      }`}
                    >
                      Online
                    </div>
                  </div>
                  <svg
                    className={`w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0 ${
                      darkMode ? "text-white/40" : "text-gray-400"
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              }
              align="right"
              darkMode={darkMode}
            >
              <div className="w-full max-w-xs sm:max-w-sm">
                {/* Header */}
                <div className="p-4 sm:p-6 pb-3 sm:pb-4">
                  <div className="flex items-center gap-3 sm:gap-4">
                    <div className="relative flex-shrink-0">
                      <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full p-0.5 bg-gradient-to-r from-pink-500 to-red-500">
                        <div className="w-full h-full rounded-full overflow-hidden">
                          <img
                            src="https://randomuser.me/api/portraits/women/44.jpg"
                            alt="avatar"
                            className="w-full h-full object-cover"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3
                        className={`text-base sm:text-lg font-bold truncate ${
                          darkMode ? "text-white" : "text-gray-900"
                        }`}
                      >
                        {user ? user?.first_name + " " + user?.last_name : "Guest User"} 
                      </h3>
                      <p
                        className={`text-xs sm:text-sm truncate ${
                          darkMode ? "text-white/60" : "text-gray-600"
                        }`}
                      >
                        {user ? user?.email : "guest@example.com"}
                      </p>
                      <div
                        className={`text-xs sm:text-sm mt-1 ${
                          darkMode ? "text-white/70" : "text-gray-600"
                        }`}
                      >
                        Software Engineer
                      </div>
                    </div>
                  </div>
                </div>

                {/* Menu Items */}
                <div className="px-2 sm:px-3 pb-3">
                  <div className="space-y-0.5 sm:space-y-1">
                    <button
                      onClick={() => navigate("/settings")}
                      className={`w-full flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2 sm:py-2.5 rounded-lg sm:rounded-xl text-left transition-all duration-200 group ${
                        darkMode ? "hover:bg-white/10" : "hover:bg-gray-50"
                      }`}
                    >
                      <div className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center rounded-lg sm:rounded-xl bg-gradient-to-br from-pink-600 to-red-500 shadow-md group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                        <svg
                          className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94 1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div
                          className={`text-xs sm:text-sm font-semibold truncate ${
                            darkMode ? "text-white" : "text-gray-900"
                          }`}
                        >
                          Settings
                        </div>
                        <div
                          className={`text-xs truncate ${
                            darkMode ? "text-white/50" : "text-gray-500"
                          }`}
                        >
                          Preferences & privacy
                        </div>
                      </div>
                      <svg
                        className={`w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0 ${
                          darkMode ? "text-white/30" : "text-gray-400"
                        } group-hover:scale-110 transition-transform duration-200`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </button>

                    <button
                      onClick={() => navigate("/help")}
                      className={`w-full flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2 sm:py-2.5 rounded-lg sm:rounded-xl text-left transition-all duration-200 group ${
                        darkMode ? "hover:bg-white/10" : "hover:bg-gray-50"
                      }`}
                    >
                      <div className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center rounded-lg sm:rounded-xl bg-gradient-to-br from-pink-600 to-red-500 shadow-md group-hover:scale-110 transition-transform duration-300">
                        <svg
                          className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                          />
                        </svg>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div
                          className={`text-xs sm:text-sm font-semibold truncate ${
                            darkMode ? "text-white" : "text-gray-900"
                          }`}
                        >
                          Help & Support
                        </div>
                        <div
                          className={`text-xs truncate ${
                            darkMode ? "text-white/50" : "text-gray-500"
                          }`}
                        >
                          Get assistance
                        </div>
                      </div>
                      <svg
                        className={`w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0 ${
                          darkMode ? "text-white/30" : "text-gray-400"
                        } group-hover:scale-110 transition-transform duration-200`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </button>
                  </div>

                  {/* Divider */}
                  <div
                    className={`my-2 sm:my-3 mx-2 sm:mx-3 h-px ${
                      darkMode
                        ? "bg-gradient-to-r from-transparent via-white/10 to-transparent"
                        : "bg-gradient-to-r from-transparent via-gray-200 to-transparent"
                    }`}
                  ></div>

                  {/* Sign Out Button */}
                  <button
                    onClick={logout}
                    className={`w-full flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2 sm:py-2.5 rounded-lg sm:rounded-xl text-left transition-all duration-200 group ${
                      darkMode
                        ? "hover:bg-red-500/10 hover:text-red-400"
                        : "hover:bg-red-50 hover:text-red-600"
                    }`}
                  >
                    <div className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center rounded-lg sm:rounded-xl bg-gradient-to-br from-pink-600 to-red-500 shadow-md group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                      <svg
                        className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                        />
                      </svg>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-xs sm:text-sm font-semibold truncate">
                        Sign Out
                      </div>
                      <div
                        className={`${
                          darkMode ? "text-white/50" : "text-gray-500"
                        } text-xs truncate`}
                      >
                        Log out of your account
                      </div>
                    </div>
                    <svg
                      className={`w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0 ${
                        darkMode ? "text-white/30" : "text-gray-400"
                      } group-hover:scale-110 transition-transform duration-200`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </Dropdown>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div
        ref={mainContentRef}
        className="flex mt-4 relative"
        style={{ height: `calc(100vh - ${mainTopOffset}px)` }}
      >
        {/* Video Area */}
        <div
          className={`${
            layout === "spotlight"
              ? cameraBarCollapsed
                ? "flex-1"
                : "basis-[75%] translate-x-1 md:translate-x-2"
              : "flex-1"
          } flex flex-col relative transform transition-all duration-500 ease-in-out ${
            layout === "grid" ? "ml-4 md:ml-8 mr-4 md:mr-8" : "ml-2 md:ml-6"
          }`}
        >
          {/* Video Grid */}
          <div className="flex-1 p-3 pb-4 relative">
            <div
              ref={leftActiveRef}
              className={`grid gap-2 h-full ${
                layout === "grid"
                  ? "grid-cols-3 grid-rows-[270px_270px]"
                  : layout === "spotlight"
                  ? "grid-cols-1 max-w-7xl mx-auto"
                  : layout === "gallery"
                  ? "grid-cols-3 lg:grid-cols-4 xl:grid-cols-5"
                  : "grid-cols-1 lg:grid-cols-4"
              }`}
            >
              {layout === "grid"
                ? getVisibleParticipants().map((participant, index) => (
                    <div
                      key={participant.id}
                      className={`relative rounded-2xl overflow-visible transition-all duration-300 group ${
                        participantConnectionOpenId === participant.id
                          ? "z-[150]"
                          : ""
                      } ${
                        participant.id === pinnedParticipant
                          ? "border-2 border-yellow-500 shadow-2xl shadow-yellow-500/30"
                          : participant.id === spotlightedParticipant
                          ? "border-2 border-purple-500 shadow-2xl shadow-purple-500/30"
                          : "border-2 border-transparent dark:border-white/10 hover:dark:border-white/30 border-gray-200 hover:border-gray-400 hover:shadow-xl hover:ring-2 hover:ring-gray-400"
                      } h-[270px]`}
                      style={
                        participant.isSpeaking
                          ? {
                              background:
                                "linear-gradient(45deg, #ec4899, #ef4444)",
                              padding: "2px",
                            }
                          : {}
                      }
                    >
                      <div className="w-full h-full rounded-2xl overflow-hidden bg-transparent">
                        {/* Video Background */}
                        <div
                          className={`w-full h-full ${
                            darkMode
                              ? "bg-gradient-to-br from-gray-800 to-gray-900"
                              : "bg-gradient-to-br from-gray-100 to-gray-200"
                          } flex items-center justify-center relative`}
                        >
                          {participant.isVideoOn ? (
                            <div className="text-center">
                              <img
                                src={participant.avatar}
                                alt={participant.name}
                                className="w-20 h-20 rounded-full mx-auto mb-3 shadow-lg"
                              />
                              <p className="text-sm opacity-75">Live Video</p>
                            </div>
                          ) : (
                            <div className="text-center">
                              <div
                                className={`w-20 h-20 rounded-full mx-auto mb-3 flex items-center justify-center ${
                                  darkMode ? "bg-gray-700" : "bg-gray-300"
                                } shadow-lg`}
                              >
                                <User size={32} className="opacity-50" />
                              </div>
                              <p className="text-sm opacity-75">Camera Off</p>
                            </div>
                          )}

                          {/* Name/Role Overlay */}
                          <div className="absolute bottom-3 left-3 z-30 pointer-events-none">
                            <div
                              className={`text-sm font-semibold ${
                                darkMode ? "text-white" : "text-gray-900"
                              }`}
                            >
                              {participant.name}
                            </div>
                            <div
                              className={`text-[11px] ${
                                darkMode ? "text-white/80" : "text-gray-800"
                              }`}
                            >
                              {participant.role}
                            </div>
                          </div>

                          {/* Connection Quality Indicator */}
                          <div className="absolute top-3 right-3 participant-more-container">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setParticipantMenuOpenId(
                                  participant.id === participantMenuOpenId
                                    ? null
                                    : participant.id
                                );
                              }}
                              className={`p-2 rounded-full ${
                                darkMode
                                  ? "bg-black/50 text-white hover:bg-black/70"
                                  : "bg-white/80 text-gray-700 hover:bg-white"
                              } shadow-sm`}
                              aria-label="More actions"
                              title="More actions"
                            >
                              <MoreVertical size={14} />
                            </button>
                            {participantMenuOpenId === participant.id && (
                              <div
                                className={`absolute right-0 mt-2 w-56 rounded-xl shadow-2xl z-[9999] border ${
                                  darkMode
                                    ? "bg-[#1a1a2b] border-white/10"
                                    : "bg-white border-gray-200"
                                }`}
                              >
                                <div className="py-2">
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handlePinParticipant(participant.id);
                                      setParticipantMenuOpenId(null);
                                    }}
                                    className={`w-full text-left px-3 py-2 text-sm ${
                                      darkMode
                                        ? "text-white/90 hover:bg-white/10"
                                        : "text-gray-800 hover:bg-gray-100"
                                    } transition-colors`}
                                  >
                                    <span className="flex items-center gap-2">
                                      <Pin size={14} className="opacity-80" />
                                      <span>Pin to stage</span>
                                    </span>
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setShowChat(true);
                                      setParticipantMenuOpenId(null);
                                    }}
                                    className={`w-full text-left px-3 py-2 text-sm ${
                                      darkMode
                                        ? "text-white/90 hover:bg-white/10"
                                        : "text-gray-800 hover:bg-gray-100"
                                    } transition-colors`}
                                  >
                                    <span className="flex items-center gap-2">
                                      <MessageCircle
                                        size={14}
                                        className="opacity-80"
                                      />
                                      <span>Send private message</span>
                                    </span>
                                  </button>
                                  <div
                                    className={`px-3 py-2 text-xs ${
                                      darkMode
                                        ? "text-white/60"
                                        : "text-gray-500"
                                    }`}
                                  >
                                    User volume
                                  </div>
                                  <div className="px-3 pb-2">
                                    <input
                                      type="range"
                                      min={0}
                                      max={100}
                                      value={
                                        participantVolumeById[participant.id] ??
                                        100
                                      }
                                      onChange={(e) => {
                                        const val = Number(e.target.value);
                                        (
                                          e.target as HTMLInputElement
                                        ).style.setProperty(
                                          "--percent",
                                          `${val}%`
                                        );
                                        setParticipantVolumeById((v) => ({
                                          ...v,
                                          [participant.id]: val,
                                        }));
                                      }}
                                      className="w-full h-2 rounded-lg appearance-none gradient-range"
                                      style={{
                                        ["--percent" as any]: `${
                                          participantVolumeById[
                                            participant.id
                                          ] ?? 100
                                        }%`,
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Top-left Connection Signal */}
                        <div
                          className={`absolute top-3 left-3 participant-connection-container ${
                            participantConnectionOpenId === participant.id
                              ? "z-[9999]"
                              : ""
                          }`}
                        >
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setParticipantConnectionOpenId(
                                participant.id === participantConnectionOpenId
                                  ? null
                                  : participant.id
                              );
                            }}
                            className={`${
                              darkMode
                                ? "bg-black/50 text-white hover:bg-black/70"
                                : "bg-white/80 text-gray-700 hover:bg-white"
                            } p-2 rounded-full shadow-sm transition`}
                            aria-label="Connection info"
                            title="Connection info"
                          >
                            {getConnectionIcon(participant.connection)}
                          </button>
                          {participantConnectionOpenId === participant.id && (
                            <div
                              className={`absolute left-0 mt-2 w-64 rounded-lg shadow-2xl border z-[9999] ${
                                darkMode
                                  ? "bg-[#1a1a2b] border-white/10 text-white"
                                  : "bg-white border-gray-200 text-gray-900"
                              }`}
                            >
                              <div className="px-3 py-2 text-xs font-semibold flex items-center gap-2">
                                <span>Connection:</span>
                                <span className="text-green-500">Good</span>
                              </div>
                              <div
                                className={`${
                                  darkMode
                                    ? "border-white/10"
                                    : "border-gray-200"
                                } border-t`}
                              />
                              <div className="px-3 py-2 text-xs space-y-1.5">
                                <div className="flex items-center justify-between">
                                  <span>Bitrate</span>
                                  <span className="flex items-center gap-1.5">
                                    <ArrowDown
                                      size={12}
                                      className="opacity-70"
                                    />{" "}
                                    N/A{" "}
                                    <ArrowUp size={12} className="opacity-70" />{" "}
                                    14 Kbps
                                  </span>
                                </div>
                                <div className="flex items-center justify-between">
                                  <span>Packet loss</span>
                                  <span className="flex items-center gap-1.5">
                                    <ArrowDown
                                      size={12}
                                      className="opacity-70"
                                    />{" "}
                                    0%{" "}
                                    <ArrowUp size={12} className="opacity-70" />{" "}
                                    0%
                                  </span>
                                </div>
                                <div className="flex items-center justify-between">
                                  <span>Resolution</span>
                                  <span>N/A</span>
                                </div>
                                <div className="flex items-center justify-between">
                                  <span>Frame rate</span>
                                  <span>N/A</span>
                                </div>
                                <div className="flex items-center justify-between">
                                  <span>Codecs (A/V)</span>
                                  <span>opus</span>
                                </div>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setParticipantConnectionExpandedById(
                                      (v) => ({
                                        ...v,
                                        [participant.id]: !(
                                          v[participant.id] ?? false
                                        ),
                                      })
                                    );
                                  }}
                                  className={`${
                                    darkMode
                                      ? "text-blue-400 hover:text-blue-300"
                                      : "text-blue-600 hover:text-blue-700"
                                  } text-xs font-medium mt-1`}
                                >
                                  {participantConnectionExpandedById[
                                    participant.id
                                  ]
                                    ? "Show less"
                                    : "Show more"}
                                </button>
                                {participantConnectionExpandedById[
                                  participant.id
                                ] && (
                                  <div
                                    className={`pt-2 mt-1 border-t ${
                                      darkMode
                                        ? "border-white/10"
                                        : "border-gray-200"
                                    } space-y-1.5 text-xs`}
                                  >
                                    <div className="flex items-center justify-between">
                                      <span>Estimated bandwidth</span>
                                      <span className="flex items-center gap-1.5">
                                        <ArrowDown
                                          size={12}
                                          className="opacity-70"
                                        />{" "}
                                        N/A{" "}
                                        <ArrowUp
                                          size={12}
                                          className="opacity-70"
                                        />{" "}
                                        106 Kbps
                                      </span>
                                    </div>
                                    <div className="flex items-center justify-between">
                                      <span>Remote address</span>
                                      <span>undefined (p2p)</span>
                                    </div>
                                    <div className="flex items-center justify-between">
                                      <span>Remote ports</span>
                                      <span>53681, 50690</span>
                                    </div>
                                    <div className="flex items-center justify-between">
                                      <span>Local address</span>
                                      <span>undefined</span>
                                    </div>
                                    <div className="flex items-center justify_between">
                                      <span>Local ports</span>
                                      <span>59915, 63952</span>
                                    </div>
                                    <div className="flex items-center justify_between">
                                      <span>Transport</span>
                                      <span>udp</span>
                                    </div>
                                    <div className="flex items_center justify_between">
                                      <span>Server count</span>
                                      <span>1</span>
                                    </div>
                                    <div className="flex items-center justify-between">
                                      <span>Audio SSRC</span>
                                      <span>2229027577</span>
                                    </div>
                                    <div className="flex items-center justify-between">
                                      <span>Video SSRC</span>
                                      <span>N/A</span>
                                    </div>
                                    <div className="flex items-center justify-between">
                                      <span>Participant id</span>
                                      <span>dab076cb</span>
                                    </div>
                                    <div className="flex items-center justify-between">
                                      <span>E2EE verified</span>
                                      <span>no</span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                : participants
                    .filter(
                      (participant) =>
                        layout !== "spotlight" ||
                        participant.name === "Alex Johnson"
                    )
                    .map((participant, index) => (
                      <div
                        key={participant.id}
                        className={`relative rounded-2xl overflow-visible transition-all duration-300 group ${
                          participantConnectionOpenId === participant.id
                            ? "z-[150]"
                            : ""
                        } ${
                          participant.id === pinnedParticipant
                            ? "border-2 border-yellow-500 shadow-2xl shadow-yellow-500/30"
                            : participant.id === spotlightedParticipant
                            ? "border-2 border-purple-500 shadow-2xl shadow-purple-500/30"
                            : "border-2 border-transparent dark:border-white/10 hover:dark:border-white/30 border-gray-200 hover:border-gray-400 hover:shadow-xl hover:ring-2 hover:ring-gray-400"
                        } ${
                          layout === "spotlight" && index === 0
                            ? "col-span-1 h-[540px]"
                            : "h-[270px]"
                        }`}
                        style={
                          participant.isSpeaking
                            ? {
                                background:
                                  "linear-gradient(45deg, #ec4899, #ef4444)",
                                padding: "2px",
                              }
                            : {}
                        }
                      >
                        <div className="w-full h-full rounded-2xl overflow-hidden bg-transparent">
                          {/* Video Background */}
                          <div
                            className={`w-full h-full ${
                              darkMode
                                ? "bg-gradient-to-br from-gray-800 to-gray-900"
                                : "bg-gradient-to-br from-gray-100 to-gray-200"
                            } flex items-center justify-center relative`}
                          >
                            {participant.isVideoOn ? (
                              <div className="text-center">
                                <img
                                  src={participant.avatar}
                                  alt={participant.name}
                                  className="w-20 h-20 rounded-full mx-auto mb-3 shadow-lg"
                                />
                                <p className="text-sm opacity-75">Live Video</p>
                              </div>
                            ) : (
                              <div className="text-center">
                                <div
                                  className={`w-20 h-20 rounded-full mx-auto mb-3 flex items-center justify-center ${
                                    darkMode ? "bg-gray-700" : "bg-gray-300"
                                  } shadow-lg`}
                                >
                                  <User size={32} className="opacity-50" />
                                </div>
                                <p className="text-sm opacity-75">Camera Off</p>
                              </div>
                            )}

                            {/* Name/Role Overlay */}
                            <div className="absolute bottom-3 left-3 z-30 pointer-events-none">
                              <div
                                className={`text-sm font-semibold ${
                                  darkMode ? "text-white" : "text-gray-900"
                                }`}
                              >
                                {participant.name}
                              </div>
                              <div
                                className={`text-[11px] ${
                                  darkMode ? "text-white/80" : "text-gray-800"
                                }`}
                              >
                                {participant.role}
                              </div>
                            </div>

                            {/* Connection Quality Indicator */}
                            <div className="absolute top-3 right-3 participant-more-container">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setParticipantMenuOpenId(
                                    participant.id === participantMenuOpenId
                                      ? null
                                      : participant.id
                                  );
                                }}
                                className={`p-2 rounded-full ${
                                  darkMode
                                    ? "bg-black/50 text-white hover:bg-black/70"
                                    : "bg-white/80 text-gray-700 hover:bg-white"
                                } shadow-sm`}
                                aria-label="More actions"
                                title="More actions"
                              >
                                <MoreVertical size={14} />
                              </button>
                              {participantMenuOpenId === participant.id && (
                                <div
                                  className={`absolute right-0 mt-2 w-56 rounded-xl shadow-2xl z-[9999] border ${
                                    darkMode
                                      ? "bg-[#1a1a2b] border-white/10"
                                      : "bg-white border-gray-200"
                                  }`}
                                >
                                  <div className="py-2">
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handlePinParticipant(participant.id);
                                        setParticipantMenuOpenId(null);
                                      }}
                                      className={`w-full text-left px-3 py-2 text-sm ${
                                        darkMode
                                          ? "text-white/90 hover:bg-white/10"
                                          : "text-gray-800 hover:bg-gray-100"
                                      } transition-colors`}
                                    >
                                      <span className="flex items-center gap-2">
                                        <Pin size={14} className="opacity-80" />
                                        <span>Pin to stage</span>
                                      </span>
                                    </button>
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setShowChat(true);
                                        setParticipantMenuOpenId(null);
                                      }}
                                      className={`w-full text-left px-3 py-2 text-sm ${
                                        darkMode
                                          ? "text-white/90 hover:bg-white/10"
                                          : "text-gray-800 hover:bg-gray-100"
                                      } transition-colors`}
                                    >
                                      <span className="flex items-center gap-2">
                                        <MessageCircle
                                          size={14}
                                          className="opacity-80"
                                        />
                                        <span>Send private message</span>
                                      </span>
                                    </button>
                                    <div
                                      className={`px-3 py-2 text-xs ${
                                        darkMode
                                          ? "text-white/60"
                                          : "text-gray-500"
                                      }`}
                                    >
                                      User volume
                                    </div>
                                    <div className="px-3 pb-2">
                                      <input
                                        type="range"
                                        min={0}
                                        max={100}
                                        value={
                                          participantVolumeById[
                                            participant.id
                                          ] ?? 100
                                        }
                                        onChange={(e) => {
                                          const val = Number(e.target.value);
                                          (
                                            e.target as HTMLInputElement
                                          ).style.setProperty(
                                            "--percent",
                                            `${val}%`
                                          );
                                          setParticipantVolumeById((v) => ({
                                            ...v,
                                            [participant.id]: val,
                                          }));
                                        }}
                                        className="w-full h-2 rounded-lg appearance-none gradient-range"
                                        style={{
                                          ["--percent" as any]: `${
                                            participantVolumeById[
                                              participant.id
                                            ] ?? 100
                                          }%`,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Top-left Connection Signal */}
                          <div
                            className={`absolute top-3 left-3 participant-connection-container ${
                              participantConnectionOpenId === participant.id
                                ? "z-[9999]"
                                : ""
                            }`}
                          >
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setParticipantConnectionOpenId(
                                  participant.id === participantConnectionOpenId
                                    ? null
                                    : participant.id
                                );
                              }}
                              className={`${
                                darkMode
                                  ? "bg-black/50 text-white hover:bg-black/70"
                                  : "bg-white/80 text-gray-700 hover:bg-white"
                              } p-2 rounded-full shadow-sm transition`}
                              aria-label="Connection info"
                              title="Connection info"
                            >
                              {getConnectionIcon(participant.connection)}
                            </button>
                            {participantConnectionOpenId === participant.id && (
                              <div
                                className={`absolute left-0 mt-2 w-64 rounded-lg shadow-2xl border z-[9999] ${
                                  darkMode
                                    ? "bg-[#1a1a2b] border-white/10 text-white"
                                    : "bg-white border-gray-200 text-gray-900"
                                }`}
                              >
                                <div className="px-3 py-2 text-xs font-semibold flex items-center gap-2">
                                  <span>Connection:</span>
                                  <span className="text-green-500">Good</span>
                                </div>
                                <div
                                  className={`${
                                    darkMode
                                      ? "border-white/10"
                                      : "border-gray-200"
                                  } border-t`}
                                />
                                <div className="px-3 py-2 text-xs space-y-1.5">
                                  <div className="flex items-center justify-between">
                                    <span>Bitrate</span>
                                    <span className="flex items-center gap-1.5">
                                      <ArrowDown
                                        size={12}
                                        className="opacity-70"
                                      />{" "}
                                      N/A{" "}
                                      <ArrowUp
                                        size={12}
                                        className="opacity-70"
                                      />{" "}
                                      14 Kbps
                                    </span>
                                  </div>
                                  <div className="flex items-center justify-between">
                                    <span>Packet loss</span>
                                    <span className="flex items-center gap-1.5">
                                      <ArrowDown
                                        size={12}
                                        className="opacity-70"
                                      />{" "}
                                      0%{" "}
                                      <ArrowUp
                                        size={12}
                                        className="opacity-70"
                                      />{" "}
                                      0%
                                    </span>
                                  </div>
                                  <div className="flex items-center justify-between">
                                    <span>Resolution</span>
                                    <span>N/A</span>
                                  </div>
                                  <div className="flex items-center justify-between">
                                    <span>Frame rate</span>
                                    <span>N/A</span>
                                  </div>
                                  <div className="flex items-center justify-between">
                                    <span>Codecs (A/V)</span>
                                    <span>opus</span>
                                  </div>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setParticipantConnectionExpandedById(
                                        (v) => ({
                                          ...v,
                                          [participant.id]: !(
                                            v[participant.id] ?? false
                                          ),
                                        })
                                      );
                                    }}
                                    className={`${
                                      darkMode
                                        ? "text-blue-400 hover:text-blue-300"
                                        : "text-blue-600 hover:text-blue-700"
                                    } text-xs font-medium mt-1`}
                                  >
                                    {participantConnectionExpandedById[
                                      participant.id
                                    ]
                                      ? "Show less"
                                      : "Show more"}
                                  </button>
                                  {participantConnectionExpandedById[
                                    participant.id
                                  ] && (
                                    <div
                                      className={`pt-2 mt-1 border-t ${
                                        darkMode
                                          ? "border-white/10"
                                          : "border-gray-200"
                                      } space-y-1.5 text-xs`}
                                    >
                                      <div className="flex items-center justify-between">
                                        <span>Estimated bandwidth</span>
                                        <span className="flex items-center gap-1.5">
                                          <ArrowDown
                                            size={12}
                                            className="opacity-70"
                                          />{" "}
                                          N/A{" "}
                                          <ArrowUp
                                            size={12}
                                            className="opacity-70"
                                          />{" "}
                                          106 Kbps
                                        </span>
                                      </div>
                                      <div className="flex items-center justify-between">
                                        <span>Remote address</span>
                                        <span>undefined (p2p)</span>
                                      </div>
                                      <div className="flex items-center justify-between">
                                        <span>Remote ports</span>
                                        <span>53681, 50690</span>
                                      </div>
                                      <div className="flex items-center justify-between">
                                        <span>Local address</span>
                                        <span>undefined</span>
                                      </div>
                                      <div className="flex items-center justify_between">
                                        <span>Local ports</span>
                                        <span>59915, 63952</span>
                                      </div>
                                      <div className="flex items-center justify_between">
                                        <span>Transport</span>
                                        <span>udp</span>
                                      </div>
                                      <div className="flex items_center justify_between">
                                        <span>Server count</span>
                                        <span>1</span>
                                      </div>
                                      <div className="flex items-center justify-between">
                                        <span>Audio SSRC</span>
                                        <span>2229027577</span>
                                      </div>
                                      <div className="flex items-center justify-between">
                                        <span>Video SSRC</span>
                                        <span>N/A</span>
                                      </div>
                                      <div className="flex items-center justify-between">
                                        <span>Participant id</span>
                                        <span>dab076cb</span>
                                      </div>
                                      <div className="flex items-center justify-between">
                                        <span>E2EE verified</span>
                                        <span>no</span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}

              {/* Navigation Buttons for Grid Layout */}
              {layout === "grid" && participants.length > 6 && (
                <>
                  {currentPage > 0 && (
                    <button
                      onClick={handlePreviousPage}
                      className={`absolute -left-5 top-1/2 transform -translate-y-1/2 w-6 h-10 flex items-center justify-center transition-all duration-300 ${
                        darkMode
                          ? "bg-gray-800/90 hover:bg-gray-700/90 text-white/70 hover:text-white"
                          : "bg-white/90 hover:bg-gray-50/90 text-gray-600 hover:text-gray-800"
                      } shadow-lg border ${
                        darkMode ? "border-white/10" : "border-gray-200/60"
                      } rounded-md`}
                      aria-label="Previous participants"
                      title="Previous participants"
                    >
                      <ChevronLeft className="w-3 h-3" />
                    </button>
                  )}
                  {currentPage < Math.ceil(participants.length / 6) - 1 && (
                    <button
                      onClick={handleNextPage}
                      className={`absolute -right-5 top-1/2 transform -translate-y-1/2 w-6 h-10 flex items-center justify-center transition-all duration-300 ${
                        darkMode
                          ? "bg-gray-800/90 hover:bg-gray-700/90 text-white/70 hover:text-white"
                          : "bg-white/90 hover:bg-gray-50/90 text-gray-600 hover:text-gray-800"
                      } shadow-lg border ${
                        darkMode ? "border-white/10" : "border-gray-200/60"
                      } rounded-md`}
                      aria-label="Next participants"
                      title="Next participants"
                    >
                      <ChevronRight className="w-3 h-3" />
                    </button>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Enhanced Control Bar */}
          <div
            className={`flex-1 flex items-center justify-center pb-4 ${
              layout === "spotlight" ? "ml-[2%]" : ""
            }`}
          >
            <div className="flex items-center justify-center">
              <div
                className={`flex items-center gap-4 px-8 py-4 rounded-full ${
                  darkMode ? "bg-black/40" : "bg-white/40"
                } backdrop-blur-xl border ${
                  darkMode ? "border-white/10" : "border-gray-200/50"
                } shadow-lg`}
              >
                {/* Mic */}
                <div className="relative mic-dropdown-container">
                  <button
                    onClick={() => setIsMuted(!isMuted)}
                    className={`p-4 rounded-full transition-all duration-200 relative ${
                      isMuted
                        ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                        : darkMode
                        ? "bg-white/10 text-white hover:bg-white/20"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    {isMuted ? <MicOff size={24} /> : <Mic size={24} />}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowMicDropdown(!showMicDropdown);
                      }}
                      className={`absolute -top-1 -right-1 p-1 rounded-full transition-all duration-200 ${
                        darkMode
                          ? "bg-gray-800/80 text-white hover:bg-gray-700/80"
                          : "bg-white/90 text-gray-600 hover:bg-gray-100/90"
                      } shadow-sm`}
                    >
                      <ChevronUp
                        size={12}
                        className={`transition-transform duration-200 ${
                          showMicDropdown ? "rotate-180" : ""
                        }`}
                      />
                    </button>
                  </button>

                  {/* Audio Settings Dropdown */}
                  {showMicDropdown && (
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-3 w-56 rounded-xl shadow-2xl backdrop-blur-xl z-[9999]">
                      <div
                        className={`${
                          darkMode
                            ? "bg-gradient-to-br from-gray-900/95 via-gray-800/95 to-gray-900/95 border border-white/10"
                            : "bg-gradient-to-br from-white/95 via-gray-50/95 to-white/95 border border-gray-200/50"
                        } rounded-xl px-2 py-3 shadow-xl`}
                      >
                        {/* Microphone Section */}
                        <div className="mb-2 pt-1">
                          <div className="flex items-center gap-1.5 mb-1.5">
                            <div
                              className={`p-0.5 rounded ${
                                darkMode ? "bg-white/5" : "bg-gray-100"
                              }`}
                            >
                              <Mic
                                size={10}
                                className={
                                  darkMode ? "text-white/70" : "text-gray-600"
                                }
                              />
                            </div>
                            <h4
                              className={`text-xs font-semibold uppercase tracking-wider ${
                                darkMode ? "text-white/50" : "text-gray-400"
                              }`}
                            >
                              Microphone
                            </h4>
                          </div>
                          <div className="space-y-0.5">
                            {mockAudioDevices.microphones.map((mic) => (
                              <button
                                key={mic.id}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMicrophoneSelect(mic.name);
                                }}
                                onMouseDown={(e) => e.preventDefault()}
                                tabIndex={-1}
                                type="button"
                                className={`w-full text-left p-1.5 rounded-lg transition-all duration-200 focus:outline-none ${
                                  selectedMicrophone === mic.name
                                    ? `${
                                        darkMode
                                          ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                                          : "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                                      }`
                                    : `${
                                        darkMode
                                          ? "text-white/80"
                                          : "text-gray-700"
                                      }`
                                }`}
                              >
                                <div className="flex items-center justify-between">
                                  <span className="text-xs font-medium truncate">
                                    {mic.name}
                                  </span>
                                  {selectedMicrophone === mic.name && (
                                    <div
                                      className={`p-0.5 rounded-full ${
                                        darkMode
                                          ? "bg-pink-500/20"
                                          : "bg-pink-100"
                                      }`}
                                    >
                                      <CheckCircle
                                        size={10}
                                        className="text-white"
                                      />
                                    </div>
                                  )}
                                </div>
                              </button>
                            ))}
                          </div>
                        </div>

                        {/* Speaker Section */}
                        <div>
                          <div className="flex items-center gap-1.5 mb-1.5">
                            <div
                              className={`p-0.5 rounded ${
                                darkMode ? "bg-white/5" : "bg-gray-100"
                              }`}
                            >
                              <Volume2
                                size={10}
                                className={
                                  darkMode ? "text-white/70" : "text-gray-600"
                                }
                              />
                            </div>
                            <h4
                              className={`text-xs font-semibold uppercase tracking-wider ${
                                darkMode ? "text-white/50" : "text-gray-400"
                              }`}
                            >
                              Speaker
                            </h4>
                          </div>
                          <div className="space-y-0.5">
                            {mockAudioDevices.speakers.map((speaker) => (
                              <button
                                key={speaker.id}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSpeakerSelect(speaker.name);
                                }}
                                onMouseDown={(e) => e.preventDefault()}
                                tabIndex={-1}
                                type="button"
                                className={`w-full text-left p-1.5 rounded-lg transition-all duration-200 focus:outline-none ${
                                  selectedSpeaker === speaker.name
                                    ? `${
                                        darkMode
                                          ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                                          : "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                                      }`
                                    : `${
                                        darkMode
                                          ? "text-white/80"
                                          : "text-gray-700"
                                      }`
                                }`}
                              >
                                <div className="flex items-center justify-between">
                                  <span className="text-xs font-medium truncate">
                                    {speaker.name}
                                  </span>
                                  {selectedSpeaker === speaker.name && (
                                    <div
                                      className={`p-0.5 rounded-full ${
                                        darkMode
                                          ? "bg-pink-500/20"
                                          : "bg-pink-100"
                                      }`}
                                    >
                                      <CheckCircle
                                        size={10}
                                        className="text-white"
                                      />
                                    </div>
                                  )}
                                </div>
                              </button>
                            ))}
                          </div>
                        </div>

                        {/* Noise suppression */}
                        <div
                          className={`mt-4 pt-3 pb-2 border-t ${
                            darkMode ? "border-white/10" : "border-gray-200/70"
                          }`}
                        >
                          <label className="flex items-center gap-2 text-xs cursor-pointer select-none">
                            <input
                              type="checkbox"
                              checked={enableNoiseSuppression}
                              onChange={(e) =>
                                setEnableNoiseSuppression(e.target.checked)
                              }
                              className="h-3.5 w-3.5 rounded border-gray-300 text-pink-500 focus:ring-0 focus:outline-none"
                            />
                            <span
                              className={
                                darkMode ? "text-white/80" : "text-gray-700"
                              }
                            >
                              Noise suppression
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Camera */}
                <div className="relative camera-dropdown-container">
                  <button
                    onClick={() => setIsVideoOn(!isVideoOn)}
                    className={`p-4 rounded-full transition-all duration-200 relative ${
                      !isVideoOn
                        ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                        : darkMode
                        ? "bg-white/10 text-white hover:bg-white/20"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    {isVideoOn ? <Video size={24} /> : <VideoOff size={24} />}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowCameraDropdown(!showCameraDropdown);
                      }}
                      className={`absolute -top-1 -right-1 p-1 rounded-full transition-all duration-200 ${
                        darkMode
                          ? "bg-gray-800/80 text-white hover:bg-gray-700/80"
                          : "bg-white/90 text-gray-600 hover:bg-gray-100/90"
                      } shadow-sm`}
                    >
                      <ChevronUp
                        size={12}
                        className={`transition-transform duration-200 ${
                          showCameraDropdown ? "rotate-180" : ""
                        }`}
                      />
                    </button>
                  </button>

                  {/* Camera Settings Dropdown */}
                  {showCameraDropdown && (
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-3 w-64 rounded-xl shadow-2xl backdrop-blur-xl z-[9999]">
                      <div
                        className={`${
                          darkMode
                            ? "bg-gradient-to-br from-gray-900/95 via-gray-800/95 to-gray-900/95 border border-white/10"
                            : "bg-gradient-to-br from-white/95 via-gray-50/95 to-white/95 border border-gray-200/50"
                        } rounded-xl px-2 py-3 shadow-xl`}
                      >
                        {/* Preview */}
                        <div
                          className={`rounded-lg overflow-hidden mb-2 ${
                            darkMode ? "bg-gray-800" : "bg-gray-200"
                          } aspect-video flex items-center justify-center`}
                        >
                          <div className="w-full h-full flex items-center justify-center">
                            <div
                              className={`w-20 h-20 rounded-full flex items-center justify-center ${
                                darkMode ? "bg-gray-700" : "bg-gray-300"
                              }`}
                            >
                              <Camera
                                size={24}
                                className={
                                  darkMode ? "text-white/60" : "text-gray-600"
                                }
                              />
                            </div>
                          </div>
                        </div>

                        {/* Camera List */}
                        <div className="space-y-0.5">
                          {mockAudioDevices.cameras.map((cam) => (
                            <button
                              key={cam.id}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCameraSelect(cam.name);
                              }}
                              onMouseDown={(e) => e.preventDefault()}
                              tabIndex={-1}
                              type="button"
                              className={`w-full text-left p-1.5 rounded-lg transition-all duration-200 focus:outline-none ${
                                selectedCamera === cam.name
                                  ? `${
                                      darkMode
                                        ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                                        : "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                                    }`
                                  : `${
                                      darkMode
                                        ? "text-white/80"
                                        : "text-gray-700"
                                    }`
                              }`}
                            >
                              <div className="flex items-center justify-between">
                                <span className="text-xs font-medium truncate">
                                  {cam.name}
                                </span>
                                {selectedCamera === cam.name && (
                                  <div
                                    className={`p-0.5 rounded-full ${
                                      darkMode
                                        ? "bg-pink-500/20"
                                        : "bg-pink-100"
                                    }`}
                                  >
                                    <CheckCircle
                                      size={10}
                                      className="text-white"
                                    />
                                  </div>
                                )}
                              </div>
                            </button>
                          ))}
                        </div>

                        {/* Mirror my video */}
                        <div
                          className={`mt-4 pt-3 pb-2 border-t ${
                            darkMode ? "border-white/10" : "border-gray-200/70"
                          }`}
                        >
                          <label className="flex items-center gap-2 text-xs cursor-pointer select-none">
                            <input
                              type="checkbox"
                              checked={mirrorVideo}
                              onChange={(e) => setMirrorVideo(e.target.checked)}
                              className="h-3.5 w-3.5 rounded border-gray-300 text-pink-500 focus:ring-0 focus:outline-none"
                            />
                            <span
                              className={
                                darkMode ? "text-white/80" : "text-gray-700"
                              }
                            >
                              Mirror my video
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Share Screen */}
                <div className="relative screenshare-dropdown-container">
                  <button
                    onClick={() => setIsScreenSharing(!isScreenSharing)}
                    aria-label="Share screen"
                    title="Share screen"
                    className={`p-4 rounded-full transition-all duration-200 relative ${
                      isScreenSharing
                        ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                        : darkMode
                        ? "bg-white/10 text-white hover:bg-white/20"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    <ScreenShare size={24} />
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowScreenShareDropdown(!showScreenShareDropdown);
                      }}
                      className={`absolute -top-1 -right-1 p-1 rounded-full transition-all duration-200 ${
                        darkMode
                          ? "bg-gray-800/80 text-white hover:bg-gray-700/80"
                          : "bg-white/90 text-gray-600 hover:bg-gray-100/90"
                      } shadow-sm`}
                      aria-label="Open screen share options"
                    >
                      <ChevronUp
                        size={12}
                        className={`transition-transform duration-200 ${
                          showScreenShareDropdown ? "rotate-180" : ""
                        }`}
                      />
                    </button>
                  </button>

                  {showScreenShareDropdown && (
                    <div
                      className={`absolute bottom-full left-1/2 -translate-x-1/2 mb-2 rounded-xl shadow-2xl backdrop-blur-xl z-[9999] border w-64 ${
                        darkMode
                          ? "bg-black/60 border-white/10"
                          : "bg-white/95 border-gray-200/60"
                      }`}
                    >
                      <div className="py-2">
                        {[
                          {
                            label: "Share video",
                            icon: <Video size={14} />,
                            action: () => setShowShareVideoModal(true),
                          },
                          {
                            label: "Share audio",
                            icon: <Mic size={14} />,
                            action: () => setIsScreenSharing(true),
                          },
                        ].map((item) => (
                          <button
                            key={item.label}
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowScreenShareDropdown(false);
                              item.action && item.action();
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                            tabIndex={-1}
                            type="button"
                            className={`w-full text_left px-3 py-2 text-sm ${
                              darkMode
                                ? "text-white/90 hover:bg-white/10"
                                : "text-gray-800 hover:bg-gray-100"
                            } transition-colors`}
                          >
                            <span className="flex items-center gap-2">
                              <span className="opacity-80">{item.icon}</span>
                              <span>{item.label}</span>
                            </span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Raise Hand */}
                <div className="relative reactions-dropdown-container">
                  <button
                    onClick={() => setShowHandRaise(!showHandRaise)}
                    aria-label="Raise hand"
                    title="Raise hand"
                    className={`p-4 rounded-full transition-all duration-200 relative ${
                      showHandRaise
                        ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                        : darkMode
                        ? "bg-white/10 text-white hover:bg-white/20"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    <Hand size={24} />
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowReactions(!showReactions);
                      }}
                      className={`absolute -top-1 -right-1 p-1 rounded-full transition-all duration-200 ${
                        darkMode
                          ? "bg-gray-800/80 text-white hover:bg-gray-700/80"
                          : "bg-white/90 text-gray-600 hover:bg-gray-100/90"
                      } shadow-sm`}
                      aria-label="Open reactions"
                    >
                      <ChevronUp
                        size={12}
                        className={`transition-transform duration-200 ${
                          showReactions ? "rotate-180" : ""
                        }`}
                      />
                    </button>
                  </button>

                  {showReactions && (
                    <div
                      className={`absolute bottom-full left-1/2 -translate-x-1/2 mb-2 rounded-full px-6 py-3 shadow-2xl backdrop-blur-xl z-[9999] border ${
                        darkMode
                          ? "bg-black/60 border-white/10"
                          : "bg-white/90 border-gray-200/60"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        {["👍", "👏", "🙂", "😮", "🙁", "🤐"].map((emo) => (
                          <button
                            key={emo}
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowReactions(false);
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                            tabIndex={-1}
                            type="button"
                            className={`h-10 w-10 flex items-center justify-center rounded-full transition-transform duration-150 ${
                              darkMode
                                ? "hover:bg-white/10"
                                : "hover:bg-gray-100"
                            }`}
                            aria-label={`React ${emo}`}
                          >
                            <span className="text-xl leading-none">{emo}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Record */}
                <button
                  onClick={() => setIsRecording(!isRecording)}
                  aria-label="Record meeting"
                  title="Record meeting"
                  className={`p-4 rounded-full transition-all duration-200 ${
                    isRecording
                      ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                      : darkMode
                      ? "bg-white/10 text-white hover:bg-white/20"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  {isRecording ? <CircleDot size={24} /> : <Circle size={24} />}
                </button>

                {/* Captions */}
                <button
                  onClick={() => setShowCaptionsModal(true)}
                  aria-label="Configure captions"
                  title="Configure captions"
                  className={`p-4 rounded-full transition-all duration-200 ${
                    captionsEnabled
                      ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                      : darkMode
                      ? "bg-white/10 text-white hover:bg-white/20"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  <span className="text-sm font-semibold tracking-wide">
                    CC
                  </span>
                </button>

                {/* Leave */}
                <button
                  onClick={handleLeaveMeeting}
                  className="px-10 py-4 rounded-full bg-red-500 text-white hover:bg-red-600 transition-all duration-200 shadow-lg"
                >
                  <Phone size={24} />
                </button>

                {/* Toggle Tile View */}
                <button
                  onClick={() =>
                    setLayout(layout === "grid" ? "spotlight" : "grid")
                  }
                  className={`p-4 rounded-full transition-all duration-200 ${
                    layout === "spotlight"
                      ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                      : darkMode
                      ? "bg-white/10 text-white hover:bg-white/20"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  {layout === "spotlight" ? (
                    <Grid size={24} />
                  ) : (
                    <Layout size={24} />
                  )}
                </button>

                {/* Fullscreen */}
                <button
                  onClick={handleToggleFullscreen}
                  aria-label={
                    isFullscreen ? "Exit fullscreen" : "Enter fullscreen"
                  }
                  title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
                  className={`p-4 rounded-full transition-all duration-200 ${
                    isFullscreen
                      ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                      : darkMode
                      ? "bg-white/10 text-white hover:bg-white/20"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  {isFullscreen ? (
                    <Minimize2 size={24} />
                  ) : (
                    <Maximize2 size={24} />
                  )}
                </button>

                {/* Participants */}
                <div className="relative participants-dropdown-container">
                  <button
                    onClick={() => {
                      setShowParticipants(!showParticipants);
                      setParticipantsTab("Meeting");
                    }}
                    className={`p-4 rounded-full transition-all duration-200 relative ${
                      showParticipants
                        ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                        : darkMode
                        ? "bg-white/10 text-white hover:bg-white/20"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    <Users size={24} />
                  </button>

                  {/* Participants Dropdown with Tabs */}
                  {showParticipants && (
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-3 w-80 rounded-xl shadow-2xl backdrop-blur-xl z-[9999]">
                      <div
                        className={`${
                          darkMode
                            ? "bg-gradient-to-br from-gray-900/95 via-gray-800/95 to-gray-900/95 border border-white/10"
                            : "bg-white border border-gray-200 shadow-xl"
                        } rounded-xl flex flex-col h-96`}
                      >
                        {/* Header */}
                        <div
                          className={`px-4 py-3 border-b ${
                            darkMode ? "border-white/10" : "border-gray-200/60"
                          }`}
                        >
                          <div className="flex items-center justify-between">
                            <div>
                              <h3 className="text-sm font-semibold">
                                Participants ({participants.length})
                              </h3>
                              <p
                                className={`${
                                  darkMode ? "text-white/60" : "text-gray-600"
                                } text-xs`}
                              >
                                Manage meeting participants
                              </p>
                            </div>
                            <div className="flex items-center gap-2">
                              <button
                                onClick={() => setShowInviteModal(true)}
                                className={`p-1.5 rounded-lg ${
                                  darkMode
                                    ? "hover:bg-white/10 text-white/70 hover:text-white"
                                    : "hover:bg-gray-100 text-gray-600 hover:text-gray-900"
                                }`}
                                aria-label="Invite participants"
                                title="Invite participants"
                              >
                                <UserPlus size={14} />
                              </button>
                              <button
                                onClick={() => setShowParticipants(false)}
                                className={`p-1 rounded ${
                                  darkMode
                                    ? "hover:bg-white/10 text-white/70 hover:text-white"
                                    : "hover:bg-gray-100 text-gray-600 hover:text-gray-900"
                                }`}
                                aria-label="Close"
                                title="Close"
                              >
                                <X size={14} />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Tabs */}
                        <div className={`px-2 pt-2`}>
                          <div className="flex items-center gap-1 px-2">
                            <button
                              type="button"
                              onClick={() => setParticipantsTab("Meeting")}
                              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
                                participantsTab === "Meeting"
                                  ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                                  : darkMode
                                  ? "text-white/80 hover:bg-white/10"
                                  : "text-gray-700 hover:bg-gray-100"
                              }`}
                            >
                              Meeting
                            </button>
                            <button
                              type="button"
                              onClick={() => setParticipantsTab("Waiting room")}
                              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
                                participantsTab === "Waiting room"
                                  ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                                  : darkMode
                                  ? "text-white/80 hover:bg-white/10"
                                  : "text-gray-700 hover:bg-gray-100"
                              }`}
                            >
                              Waiting room
                            </button>
                          </div>
                        </div>

                        {/* Body */}
                        <div className="flex-1 p-4 overflow-y-auto">
                          {participantsTab === "Meeting" ? (
                            <div className="space-y-2">
                              {participants.map((participant) => (
                                <div
                                  key={participant.id}
                                  className={`flex items-center justify-between p-2 rounded-lg ${
                                    darkMode
                                      ? "bg-white/5 hover:bg-white/10"
                                      : "bg-gray-50/80 hover:bg-gray-100/90"
                                  } transition-colors`}
                                >
                                  <div className="flex items-center gap-3">
                                    <div className="relative">
                                      <img
                                        src={participant.avatar}
                                        alt={participant.name}
                                        className="w-8 h-8 rounded-full"
                                      />
                                    </div>
                                    <div>
                                      <div className="flex items-center gap-2">
                                        <span
                                          className={`text-sm font-medium ${
                                            darkMode
                                              ? "text-white"
                                              : "text-gray-900"
                                          }`}
                                        >
                                          {participant.name}
                                        </span>
                                        {participant.isMuted && (
                                          <MicOff
                                            size={12}
                                            className="text-red-500"
                                          />
                                        )}
                                      </div>
                                      <div
                                        className={`text-xs ${
                                          darkMode
                                            ? "text-white/60"
                                            : "text-gray-600"
                                        }`}
                                      >
                                        {participant.role}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex items-center gap-2">
                                    {getConnectionIcon(
                                      participant.connection,
                                      12
                                    )}
                                    <div className="relative participants-dropdown-more-container">
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setParticipantsDropdownMenuOpenId(
                                            participant.id ===
                                              participantsDropdownMenuOpenId
                                              ? null
                                              : participant.id
                                          );
                                        }}
                                        className={`p-1 rounded ${
                                          darkMode
                                            ? "hover:bg-white/10"
                                            : "hover:bg-gray-200"
                                        }`}
                                        aria-label="More actions"
                                        title="More actions"
                                      >
                                        <MoreVertical
                                          size={12}
                                          className={
                                            darkMode
                                              ? "text-white/60"
                                              : "text-gray-600"
                                          }
                                        />
                                      </button>
                                      {participantsDropdownMenuOpenId ===
                                        participant.id && (
                                        <div
                                          className={`absolute right-0 mt-2 w-48 rounded-xl shadow-2xl z-[9999] border ${
                                            darkMode
                                              ? "bg-[#1a1a2b] border-white/10"
                                              : "bg-white border-gray-200 shadow-lg"
                                          }`}
                                        >
                                          <div className="py-2">
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handlePinParticipant(
                                                  participant.id
                                                );
                                                setParticipantsDropdownMenuOpenId(
                                                  null
                                                );
                                              }}
                                              className={`w-full text-left px-3 py-2 text-xs ${
                                                darkMode
                                                  ? "text-white/90 hover:bg-white/10"
                                                  : "text-gray-800 hover:bg-gray-100"
                                              } transition-colors`}
                                            >
                                              <span className="flex items-center gap-2">
                                                <Pin
                                                  size={12}
                                                  className="opacity-80"
                                                />
                                                <span>Pin to stage</span>
                                              </span>
                                            </button>
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setShowChat(true);
                                                setParticipantsDropdownMenuOpenId(
                                                  null
                                                );
                                              }}
                                              className={`w-full text-left px-3 py-2 text-xs ${
                                                darkMode
                                                  ? "text-white/90 hover:bg-white/10"
                                                  : "text-gray-800 hover:bg-gray-100"
                                              } transition-colors`}
                                            >
                                              <span className="flex items-center gap-2">
                                                <MessageCircle
                                                  size={12}
                                                  className="opacity-80"
                                                />
                                                <span>
                                                  Send private message
                                                </span>
                                              </span>
                                            </button>
                                            <div
                                              className={`px-3 py-2 text-xs ${
                                                darkMode
                                                  ? "text-white/60"
                                                  : "text-gray-500"
                                              }`}
                                            >
                                              User volume
                                            </div>
                                            <div className="px-3 pb-2">
                                              <input
                                                type="range"
                                                min={0}
                                                max={100}
                                                value={
                                                  participantVolumeById[
                                                    participant.id
                                                  ] ?? 100
                                                }
                                                onChange={(e) => {
                                                  const val = Number(
                                                    e.target.value
                                                  );
                                                  (
                                                    e.target as HTMLInputElement
                                                  ).style.setProperty(
                                                    "--percent",
                                                    `${val}%`
                                                  );
                                                  setParticipantVolumeById(
                                                    (v) => ({
                                                      ...v,
                                                      [participant.id]: val,
                                                    })
                                                  );
                                                }}
                                                className="w-full h-1.5 rounded-lg appearance-none gradient-range"
                                                style={{
                                                  ["--percent" as any]: `${
                                                    participantVolumeById[
                                                      participant.id
                                                    ] ?? 100
                                                  }%`,
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            // Waiting room tab
                            <div className="space-y-3">
                              {waitingParticipants.length === 0 ? (
                                <div className="text-center py-8">
                                  <Clock
                                    className={`${
                                      darkMode
                                        ? "text-white/40"
                                        : "text-gray-400"
                                    } mx-auto mb-3`}
                                    size={48}
                                  />
                                  <p
                                    className={`${
                                      darkMode
                                        ? "text-white/70"
                                        : "text-gray-600"
                                    }`}
                                  >
                                    No participants waiting
                                  </p>
                                  <p
                                    className={`text-xs mt-1 ${
                                      darkMode
                                        ? "text-white/40"
                                        : "text-gray-500"
                                    }`}
                                  >
                                    All clear!
                                  </p>
                                </div>
                              ) : (
                                <>
                                  <div className="flex items-center justify-between mb-2">
                                    <h4 className="text-xs font-semibold">
                                      Waiting Room ({waitingParticipants.length}
                                      )
                                    </h4>
                                    <button
                                      onClick={handleAdmitAll}
                                      className="py-1 px-2 text-xs bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-lg hover:from-green-600 hover:to-emerald-600 transition-all duration-200"
                                    >
                                      Admit All
                                    </button>
                                  </div>
                                  {waitingParticipants.map((participant) => (
                                    <div
                                      key={participant.id}
                                      className={`${
                                        darkMode ? "bg-white/5" : "bg-gray-50"
                                      } p-3 rounded-xl`}
                                    >
                                      <div className="flex items-center justify-between mb-2">
                                        <div className="flex items-center gap-3">
                                          <img
                                            src={participant.avatar}
                                            alt={participant.name}
                                            className="w-10 h-10 rounded-full"
                                          />
                                          <div>
                                            <h4
                                              className={`font-semibold text-sm ${
                                                darkMode
                                                  ? "text-white"
                                                  : "text-gray-900"
                                              }`}
                                            >
                                              {participant.name}
                                            </h4>
                                            <p
                                              className={`text-xs ${
                                                darkMode
                                                  ? "text-white/60"
                                                  : "text-gray-600"
                                              }`}
                                            >
                                              {participant.email}
                                            </p>
                                          </div>
                                        </div>
                                        <div
                                          className={`text-xs ${
                                            darkMode
                                              ? "text-white/70"
                                              : "text-gray-600"
                                          }`}
                                        >
                                          {participant.waitTime}
                                        </div>
                                      </div>
                                      <div className="flex items-center gap-1.5">
                                        <button
                                          onClick={() =>
                                            handleAdmitParticipant(
                                              participant.id
                                            )
                                          }
                                          className="px-2.5 py-1 text-[11px] bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-md hover:from-green-600 hover:to-emerald-600 transition-colors duration-150 font-medium"
                                        >
                                          Admit
                                        </button>
                                        <button
                                          onClick={() =>
                                            handleDenyParticipant(
                                              participant.id
                                            )
                                          }
                                          className="px-2.5 py-1 text-[11px] bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-md hover:from-red-600 hover:to-pink-600 transition-colors duration-150 font-medium"
                                        >
                                          Deny
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Chat */}
                <div className="relative chat-dropdown-container">
                  <button
                    onClick={() => setShowChat(!showChat)}
                    className={`p-4 rounded-full transition-all duration-200 relative ${
                      showChat
                        ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                        : darkMode
                        ? "bg-white/10 text-white hover:bg-white/20"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    <MessageCircle size={24} />
                  </button>

                  {/* Chat Dropdown */}
                  {showChat && (
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-3 w-80 rounded-xl shadow-2xl backdrop-blur-xl z-[9999]">
                      <div
                        className={`${
                          darkMode
                            ? "bg-gradient-to-br from-gray-900/95 via-gray-800/95 to-gray-900/95 border border-white/10"
                            : "bg-white border border-gray-200 shadow-xl"
                        } rounded-xl flex flex-col h-96`}
                      >
                        {/* Header */}
                        <div
                          className={`px-4 py-3 border-b ${
                            darkMode ? "border-white/10" : "border-gray-200/60"
                          }`}
                        >
                          <div className="flex items-center justify-between">
                            <div>
                              <h3 className="text-sm font-semibold">
                                Meeting Chat
                              </h3>
                              <p
                                className={`${
                                  darkMode ? "text-white/60" : "text-gray-600"
                                } text-xs`}
                              >
                                Share messages with participants
                              </p>
                            </div>
                            <button
                              onClick={() => setShowChat(false)}
                              className={`${
                                darkMode
                                  ? "hover:bg-white/10 text-white/70 hover:text-white"
                                  : "hover:bg-gray-100 text-gray-600 hover:text-gray-900"
                              } p-1 rounded`}
                              aria-label="Close"
                              title="Close"
                            >
                              <X size={14} />
                            </button>
                          </div>
                        </div>

                        {/* Tabs */}
                        <div
                          className={`px-2 pt-2 ${
                            darkMode ? "bg-transparent" : "bg-transparent"
                          }`}
                        >
                          <div className={`flex items-center gap-1 px-2`}>
                            <button
                              type="button"
                              onClick={() => setChatTab("Chat")}
                              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
                                chatTab === "Chat"
                                  ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                                  : darkMode
                                  ? "text-white/80 hover:bg-white/10"
                                  : "text-gray-700 hover:bg-gray-100"
                              }`}
                            >
                              Chat
                            </button>
                            <button
                              type="button"
                              onClick={() => setChatTab("Polls")}
                              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
                                chatTab === "Polls"
                                  ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                                  : darkMode
                                  ? "text-white/80 hover:bg-white/10"
                                  : "text-gray-700 hover:bg-gray-100"
                              }`}
                            >
                              Polls
                            </button>
                          </div>
                        </div>

                        {/* Messages */}
                        <div className="flex-1 p-4 overflow-y-auto space-y-3">
                          {chatTab === "Chat" ? (
                            <>
                              {chatMessages.map((message) => (
                                <div
                                  key={message.id}
                                  className={`flex ${
                                    message.isOwn
                                      ? "justify-end"
                                      : "justify-start"
                                  }`}
                                >
                                  <div
                                    className={`max-w-xs px-3 py-2 rounded-2xl ${
                                      message.isOwn
                                        ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                                        : message.type === "system"
                                        ? `${
                                            darkMode
                                              ? "bg-white/5"
                                              : "bg-gray-100/80"
                                          } ${
                                            darkMode
                                              ? "text-white/60"
                                              : "text-gray-600"
                                          } text-center`
                                        : `${
                                            darkMode
                                              ? "bg-white/10"
                                              : "bg-gray-100/90"
                                          } ${
                                            darkMode
                                              ? "text-white"
                                              : "text-gray-900"
                                          }`
                                    }`}
                                  >
                                    {message.type === "system" ? (
                                      <div className="text-xs">
                                        {message.message}
                                      </div>
                                    ) : (
                                      <div>
                                        <div className="text-xs opacity-75 mb-1">
                                          {message.sender}
                                        </div>
                                        <div className="text-sm">
                                          {message.message}
                                        </div>
                                        <div className="text-xs opacity-75 mt-1 text-right">
                                          {message.time}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                              <div ref={chatEndRef} />
                            </>
                          ) : (
                            <div className="space-y-3">
                              <div className="text-sm font-medium">
                                {poll.question}
                              </div>
                              <div className="space-y-2">
                                {poll.options.map((opt, idx) => {
                                  const percent = poll.totalVotes
                                    ? Math.round(
                                        (opt.votes * 100) / poll.totalVotes
                                      )
                                    : 0;
                                  return (
                                    <button
                                      key={idx}
                                      type="button"
                                      onClick={() => handlePollVote(idx)}
                                      disabled={pollVote !== null}
                                      className={`w-full text-left p-2 rounded-lg border transition-colors ${
                                        pollVote === idx
                                          ? "ring-2 ring-pink-500"
                                          : ""
                                      } ${
                                        darkMode
                                          ? "bg-white/5 border-white/10 text-white hover:bg-white/10 disabled:opacity-80"
                                          : "bg-gray-50/80 border-gray-200 text-gray-900 hover:bg-gray-100 disabled:opacity-80"
                                      }`}
                                    >
                                      <div className="flex items-center justify-between">
                                        <span className="text-sm">
                                          {opt.text}
                                        </span>
                                        <span
                                          className={`text-xs ${
                                            darkMode
                                              ? "text-white/70"
                                              : "text-gray-600"
                                          }`}
                                        >
                                          {percent}%
                                        </span>
                                      </div>
                                      <div
                                        className={`mt-2 h-2 w-full rounded ${
                                          darkMode
                                            ? "bg-white/10"
                                            : "bg-gray-200"
                                        }`}
                                      >
                                        <div
                                          className="h-2 rounded bg-gradient-to-r from-pink-500 to-red-500"
                                          style={{ width: `${percent}%` }}
                                        />
                                      </div>
                                    </button>
                                  );
                                })}
                              </div>
                              {pollVote !== null && (
                                <div
                                  className={`text-xs text-center ${
                                    darkMode ? "text-white/70" : "text-gray-600"
                                  }`}
                                >
                                  Thanks for voting. Total votes:{" "}
                                  {poll.totalVotes}
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        {/* Input */}
                        {chatTab === "Chat" && (
                          <div
                            className={`p-4 border-t ${
                              darkMode
                                ? "border-white/10"
                                : "border-gray-200/60"
                            }`}
                          >
                            <div className="flex gap-2">
                              <input
                                type="text"
                                value={chatMessage}
                                onChange={(e) => setChatMessage(e.target.value)}
                                placeholder="Type a message..."
                                className={`flex-1 px-3 py-2 rounded-lg text-sm outline-none border transition-all duration-200 focus:ring-2 focus:ring-pink-500/50 focus:border-transparent ${
                                  darkMode
                                    ? "bg-white/5 border-white/10 text-white placeholder-white/40 focus:ring-pink-500/50"
                                    : "bg-gray-50/80 border-gray-200 text-gray-900 placeholder-gray-500 focus:ring-pink-500/50"
                                }`}
                                onKeyPress={(e) =>
                                  e.key === "Enter" && handleSendMessage()
                                }
                              />
                              <button
                                onClick={handleSendMessage}
                                className="px-3 py-2 rounded-lg bg-gradient-to-r from-pink-500 to-red-500 text-white hover:from-pink-600 hover:to-red-600 transition-all duration-200"
                              >
                                <Send size={14} />
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Whiteboard */}
                <button
                  className={`p-4 rounded-full transition-all duration-200 relative ${
                    showWhiteboard
                      ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                      : darkMode
                      ? "bg-white/10 text-white hover:bg-white/20"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                  onClick={() => setShowWhiteboard(!showWhiteboard)}
                  aria-label="Whiteboard"
                  title="Whiteboard"
                >
                  <Presentation size={24} />
                </button>

                {/* More Options (chevron dropdown) */}
                <div className="relative more-dropdown-container">
                  <button
                    className={`p-4 rounded-full transition-all duration-200 relative ${
                      darkMode
                        ? "bg-white/10 text-white hover:bg-white/20"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                    onClick={() => setShowMoreDropdown(!showMoreDropdown)}
                    aria-label="More options"
                    aria-expanded={showMoreDropdown}
                    title="More options"
                  >
                    <MoreHorizontal size={24} />
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowMoreDropdown(!showMoreDropdown);
                      }}
                      className={`absolute -top-1 -right-1 p-1 rounded-full transition-all duration-200 ${
                        darkMode
                          ? "bg-gray-800/80 text-white hover:bg-gray-700/80"
                          : "bg-white/90 text-gray-600 hover:bg-gray-100/90"
                      } shadow-sm`}
                      aria-label="Open more actions"
                    >
                      <ChevronUp
                        size={12}
                        className={`transition-transform duration-200 ${
                          showMoreDropdown ? "rotate-180" : ""
                        }`}
                      />
                    </button>
                  </button>

                  {showMoreDropdown && (
                    <div
                      className={`absolute bottom-full left-1/2 -translate-x-1/2 mb-2 rounded-xl shadow-2xl backdrop-blur-xl z-[9999] border w-64 ${
                        darkMode
                          ? "bg-black/60 border-white/10"
                          : "bg-white/95 border-gray-200/60"
                      }`}
                    >
                      <div className="py-2">
                        {[
                          {
                            label: "Invite Participants",
                            icon: <UserPlus size={14} />,
                            action: () => setShowInviteModal(true),
                          },
                          {
                            label: "Bandwidth Control",
                            icon: <Sliders size={14} />,
                            action: () => setShowBandwidthModal(true),
                          },
                          {
                            label: "Security Options",
                            icon: <Shield size={14} />,
                          },
                          {
                            label: "Participant Statistics",
                            icon: <BarChart2 size={14} />,
                            action: () => setShowParticipantStatsModal(true),
                          },
                          {
                            label: "Manage Breakout Rooms",
                            icon: <Layout size={14} />,
                            action: () => setShowBreakoutRoomsModal(true),
                          },
                          {
                            label: "Settings",
                            icon: <Settings size={14} />,
                            action: () => setShowSettingsModal(true),
                          },
                        ].map((item) => (
                          <button
                            key={item.label}
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowMoreDropdown(false);
                              item.action && item.action();
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                            tabIndex={-1}
                            type="button"
                            className={`w-full text_left px-3 py-2 text-sm ${
                              darkMode
                                ? "text-white/90 hover:bg-white/10"
                                : "text-gray-800 hover:bg-gray-100"
                            } transition-colors`}
                          >
                            <span className="flex items-center gap-2">
                              <span className="opacity-80">{item.icon}</span>
                              <span>{item.label}</span>
                            </span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {layout === "spotlight" && (
          <div
            className={`fixed right-0 transition-all duration-500 ease-in-out ${
              cameraBarCollapsed ? "translate-x-full" : ""
            }`}
            style={{ top: mainTopOffset + 12, bottom: 0, width: "22%" }}
          >
            <div
              className={`h-[540px] flex flex-col gap-2 mr-3 md:mr-8 rounded-2xl ${
                darkMode
                  ? "bg-gradient-to-br from-gray-900/80 to-gray-800/80 border border-white/10"
                  : "bg-white/90 border border-gray-200/60"
              } backdrop-blur-xl shadow-2xl px-2 py-2 relative group`}
            >
              {/* Collapse/Expand Button */}
              <button
                onClick={() => setCameraBarCollapsed(!cameraBarCollapsed)}
                className={`absolute top-1/2 -translate-y-1/2 w-6 h-10 flex items-center justify-center transition-all duration-300 ${
                  darkMode
                    ? "bg-gray-800/90 hover:bg-gray-700/90 text-white/70 hover:text-white"
                    : "bg-white/90 hover:bg-gray-50/90 text-gray-600 hover:text-gray-800"
                } shadow-lg border ${
                  darkMode ? "border-white/10" : "border-gray-200/60"
                } ${
                  cameraBarCollapsed
                    ? "opacity-100 -left-6 rounded-l-md"
                    : "opacity-0 group-hover:opacity-100 -right-6 rounded-r-md"
                }`}
                aria-label={
                  cameraBarCollapsed
                    ? "Expand camera bar (B)"
                    : "Collapse camera bar (B)"
                }
                title={
                  cameraBarCollapsed
                    ? "Expand camera bar (B)"
                    : "Collapse camera bar (B)"
                }
              >
                <ChevronRight
                  className={`w-3 h-3 transition-transform duration-300 ${
                    cameraBarCollapsed ? "rotate-180" : ""
                  }`}
                />
              </button>
              <button
                disabled={sidePanelPage === 0}
                onClick={() =>
                  setSidePanelPage((prev) => {
                    const total = Math.max(
                      1,
                      Math.ceil(
                        participants.filter((p) => p.name !== "Alex Johnson")
                          .length / 3
                      )
                    );
                    return (prev - 1 + total) % total;
                  })
                }
                className={`sticky top-1 z-10 ${
                  darkMode
                    ? "bg-white/10 text-white border border-white/10 hover:bg-gradient-to-r hover:from-pink-500 hover:to-red-500"
                    : "bg-white/95 text-gray-800 border border-gray-200/60 hover:bg-gradient-to-r hover:from-pink-500 hover:to-red-500 hover:text-white hover:border-pink-500/30 shadow-sm"
                } disabled:opacity-50 disabled:grayscale-[40%] disabled:pointer-events-none text-[10px] font-medium px-2 py-1 rounded-md flex items-center justify-center gap-1 transition-colors`}
                aria-label="Previous speakers"
              >
                <ChevronUp size={10} />
                <span>Previous</span>
              </button>
              {participants
                .filter((p) => p.name !== "Alex Johnson")
                .slice(sidePanelPage * 3, sidePanelPage * 3 + 3)
                .map((p) => (
                  <div
                    key={p.id}
                    className={`relative rounded-lg overflow-hidden h-[152px] w-full flex items-center justify-center ${
                      darkMode
                        ? "bg-gray-800"
                        : "bg-gray-50 border border-gray-200"
                    }`}
                  >
                    <img
                      src={p.avatar}
                      alt={p.name}
                      className={`w-12 h-12 rounded-full border-2 ${
                        darkMode ? "border-white/40" : "border-white/60"
                      }`}
                    />

                    {/* Top-left Connection Signal */}
                    <div className="absolute top-2 left-2 z-50">
                      <div
                        className={`${
                          darkMode
                            ? "bg-black/80 text-white"
                            : "bg-white/95 text-gray-700"
                        } p-1.5 rounded-full shadow-lg border ${
                          darkMode ? "border-white/20" : "border-gray-200/60"
                        }`}
                      >
                        {getConnectionIcon(p.connection, 14)}
                      </div>
                    </div>

                    <div className="absolute bottom-3 left-3 z-30 pointer-events-none">
                      <div
                        className={`text-xs font-semibold ${
                          darkMode ? "text-white" : "text-gray-900"
                        } drop-shadow-sm`}
                      >
                        {p.name}
                      </div>
                      <div
                        className={`text-[10px] ${
                          darkMode ? "text-white/80" : "text-gray-600"
                        } drop-shadow-sm`}
                      >
                        {p.role}
                      </div>
                    </div>
                    <div className="absolute top-3 right-3 participant-more-container">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setParticipantMenuOpenId(
                            p.id === participantMenuOpenId ? null : p.id
                          );
                        }}
                        className={`p-1.5 rounded-full ${
                          darkMode
                            ? "bg-black/50 text-white hover:bg-black/70"
                            : "bg-white/90 text-gray-700 hover:bg-white shadow-sm"
                        } border ${
                          darkMode ? "border-white/20" : "border-gray-200/60"
                        }`}
                        aria-label="More actions"
                        title="More actions"
                      >
                        <MoreVertical size={12} />
                      </button>
                      {participantMenuOpenId === p.id && (
                        <div
                          className={`absolute right-0 mt-2 w-48 rounded-xl shadow-2xl z-[9999] border ${
                            darkMode
                              ? "bg-[#1a1a2b] border-white/10"
                              : "bg-white border-gray-200 shadow-lg"
                          }`}
                        >
                          <div className="py-2">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePinParticipant(p.id);
                                setParticipantMenuOpenId(null);
                              }}
                              className={`w-full text-left px-3 py-2 text-xs ${
                                darkMode
                                  ? "text-white/90 hover:bg-white/10"
                                  : "text-gray-800 hover:bg-gray-100"
                              } transition-colors`}
                            >
                              <span className="flex items-center gap-2">
                                <Pin size={12} className="opacity-80" />
                                <span>Pin to stage</span>
                              </span>
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowChat(true);
                                setParticipantMenuOpenId(null);
                              }}
                              className={`w-full text-left px-3 py-2 text-xs ${
                                darkMode
                                  ? "text-white/90 hover:bg-white/10"
                                  : "text-gray-800 hover:bg-gray-100"
                              } transition-colors`}
                            >
                              <span className="flex items-center gap-2">
                                <MessageCircle
                                  size={12}
                                  className="opacity-80"
                                />
                                <span>Send private message</span>
                              </span>
                            </button>
                            <div
                              className={`px-3 py-2 text-xs ${
                                darkMode ? "text-white/60" : "text-gray-500"
                              }`}
                            >
                              User volume
                            </div>
                            <div className="px-3 pb-2">
                              <input
                                type="range"
                                min={0}
                                max={100}
                                value={participantVolumeById[p.id] ?? 100}
                                onChange={(e) => {
                                  const val = Number(e.target.value);
                                  (
                                    e.target as HTMLInputElement
                                  ).style.setProperty("--percent", `${val}%`);
                                  setParticipantVolumeById((v) => ({
                                    ...v,
                                    [p.id]: val,
                                  }));
                                }}
                                className="w-full h-1.5 rounded-lg appearance-none gradient-range"
                                style={{
                                  ["--percent" as any]: `${
                                    participantVolumeById[p.id] ?? 100
                                  }%`,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              <button
                disabled={
                  sidePanelPage >=
                  Math.max(
                    1,
                    Math.ceil(
                      participants.filter((p) => p.name !== "Alex Johnson")
                        .length / 3
                    )
                  ) -
                    1
                }
                onClick={() =>
                  setSidePanelPage((prev) => {
                    const total = Math.max(
                      1,
                      Math.ceil(
                        participants.filter((p) => p.name !== "Alex Johnson")
                          .length / 3
                      )
                    );
                    if (prev >= total - 1) return prev;
                    return prev + 1;
                  })
                }
                className={`sticky bottom-0 z-10 ${
                  darkMode
                    ? "bg-white/10 text-white border border-white/10 hover:bg-gradient-to-r hover:from-pink-500 hover:to-red-500"
                    : "bg-white/95 text-gray-800 border border-gray-200/60 hover:bg-gradient-to-r hover:from-pink-500 hover:to-red-500 hover:text-white hover:border-pink-500/30 shadow-sm"
                } text-[10px] font-medium px-2 py-1 rounded-md flex items-center justify-center gap-1 transition-colors disabled:opacity-50 disabled:pointer-events-none`}
                aria-label="Next speakers"
              >
                <ChevronDown size={10} />
                <span>Next</span>
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Invite Participants Modal */}
      {showInviteModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowInviteModal(false)}
          />
          <div
            className={`relative w-full max-w-lg rounded-2xl overflow-hidden ${
              darkMode
                ? "bg-gradient-to-br from-[#12121d] to-[#1e1e2f] border border-white/10"
                : "bg-white border border-gray-200/60"
            }`}
          >
            {/* Header */}
            <div
              className={`px-6 py-5 border-b ${
                darkMode ? "border-white/10" : "border-gray-200/60"
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-r from-pink-500 to-red-500">
                  <UserPlus size={18} className="text-white" />
                </div>
                <div>
                  <h3 className="text-base font-semibold">
                    Invite Participants
                  </h3>
                  <p
                    className={`${
                      darkMode ? "text-white/60" : "text-gray-600"
                    } text-xs`}
                  >
                    Share the meeting link to invite others
                  </p>
                </div>
              </div>
            </div>

            {/* Body */}
            <div className="px-6 py-5 space-y-5">
              {/* Link */}
              <div>
                <label
                  className={`text-sm font-medium ${
                    darkMode ? "text-white/70" : "text-gray-700"
                  }`}
                >
                  Meeting link
                </label>
                <div className="mt-2 flex items-center gap-3">
                  <div className="flex-1 rounded-xl p-[2px] bg-gradient-to-r from-pink-500 to-red-500 overflow-hidden">
                    <div
                      className={`${
                        darkMode ? "bg-[#151528]" : "bg-gray-50"
                      } rounded-[10px]`}
                    >
                      <input
                        readOnly
                        value={window.location.href}
                        className={`w-full px-4 py-2 rounded-[10px] text-base outline-none border-none bg-transparent focus:ring-0 focus:border-transparent ${
                          darkMode ? "text-white" : "text-gray-900"
                        }`}
                      />
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(window.location.href);
                    }}
                    className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium ${
                      darkMode
                        ? "bg-white/10 hover:bg-gradient-to-r hover:from-pink-500 hover:to-red-500 hover:text-white"
                        : "bg-gray-200 hover:bg-gradient-to-r hover:from-pink-500 hover:to-red-500 hover:text-white"
                    }`}
                  >
                    <Copy size={14} />
                    Copy link
                  </button>
                </div>
              </div>

              {/* Share options */}
              <div>
                <div
                  className={`text-sm mb-2 font-medium ${
                    darkMode ? "text-white/70" : "text-gray-700"
                  }`}
                >
                  Share Meeting Link
                </div>
                <div className="flex items-center gap-3">
                  <button
                    className={`p-2.5 rounded-full transition-colors ${
                      darkMode
                        ? "text-white hover:bg-white/10"
                        : "text-gray-800 hover:bg-gray-100"
                    }`}
                    aria-label="Share via Gmail"
                    title="Share via Gmail"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="2"
                        y="4"
                        width="20"
                        height="16"
                        rx="2"
                        stroke={darkMode ? "#ffffff" : "#111827"}
                        strokeOpacity="0.6"
                      />
                      <path
                        d="M3 7l9 7 9-7"
                        stroke="#EA4335"
                        strokeWidth="2"
                        fill="none"
                      />
                      <path d="M3 7v10" stroke="#34A853" strokeWidth="2" />
                      <path d="M21 7v10" stroke="#4285F4" strokeWidth="2" />
                    </svg>
                  </button>
                  <button
                    className={`p-2.5 rounded-full transition-colors ${
                      darkMode
                        ? "text-white hover:bg-white/10"
                        : "text-gray-800 hover:bg-gray-100"
                    }`}
                    aria-label="Share via Outlook"
                    title="Share via Outlook"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="4"
                        y="5"
                        width="12"
                        height="14"
                        rx="2"
                        fill="#1A73E8"
                      />
                      <path
                        d="M5 8l5 4 5-4"
                        stroke="#FFFFFF"
                        strokeWidth="2"
                        fill="none"
                      />
                      <rect
                        x="14"
                        y="7"
                        width="6"
                        height="10"
                        rx="1"
                        fill="#185ABC"
                      />
                      <circle
                        cx="17"
                        cy="12"
                        r="2.3"
                        stroke="#FFFFFF"
                        strokeWidth="1.6"
                        fill="none"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            {/* Close X */}
            <button
              onClick={() => setShowInviteModal(false)}
              className={`absolute top-3 right-3 p-2 rounded-lg ${
                darkMode
                  ? "hover:bg-white/10 text-white/70 hover:text-white"
                  : "hover:bg-gray-100 text-gray-600 hover:text-gray-900"
              }`}
              aria-label="Close"
              title="Close"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      )}

      {showBandwidthModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowBandwidthModal(false)}
          />
          <div
            className={`${
              darkMode
                ? "bg-gradient-to-br from-[#12121d] to-[#1e1e2f] border border-white/10"
                : "bg-white border border-gray-200/60"
            } relative w-full max-w-lg rounded-2xl overflow-hidden`}
          >
            <button
              onClick={() => setShowBandwidthModal(false)}
              className={`${
                darkMode
                  ? "hover:bg-white/10 text-white/70 hover:text-white"
                  : "hover:bg-gray-100 text-gray-600 hover:text-gray-900"
              } absolute top-3 right-3 p-2 rounded-lg`}
              aria-label="Close"
              title="Close"
            >
              <X size={18} />
            </button>
            <div
              className={`px-6 py-5 border-b ${
                darkMode ? "border-white/10" : "border-gray-200/60"
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-r from-pink-500 to-red-500">
                  <Sliders size={18} className="text-white" />
                </div>
                <div>
                  <h3 className="text-base font-semibold">Bandwidth Control</h3>
                </div>
              </div>
            </div>
            <div className="px-6 py-6">
              <div className="mb-4">
                <div
                  className={`flex items-center justify-between text-xs ${
                    darkMode ? "text-white/60" : "text-gray-500"
                  }`}
                >
                  <span>Performance</span>
                  <span>Quality</span>
                </div>
                <div className="mt-4 relative">
                  <input
                    type="range"
                    min={1}
                    max={4}
                    step={1}
                    value={bandwidthLevel}
                    onChange={(e) =>
                      setBandwidthLevel(parseInt(e.target.value))
                    }
                    className="w-full appearance-none bg-transparent"
                    style={{
                      WebkitAppearance: "none",
                      height: "28px",
                      color: darkMode
                        ? "rgba(255,255,255,0.85)"
                        : "rgba(0,0,0,0.6)",
                      /* track and notches drawn via CSS below */
                    }}
                  />
                  <style>{`
                    input[type="range"].appearance-none{
                      background-image:
                        radial-gradient(circle, ${
                          darkMode
                            ? "rgba(17,17,17,0.85)"
                            : "rgba(17,24,39,0.8)"
                        } 0.2rem, transparent 0.21rem),
                        radial-gradient(circle, ${
                          darkMode
                            ? "rgba(17,17,17,0.85)"
                            : "rgba(17,24,39,0.8)"
                        } 0.2rem, transparent 0.21rem),
                        radial-gradient(circle, ${
                          darkMode
                            ? "rgba(17,17,17,0.85)"
                            : "rgba(17,24,39,0.8)"
                        } 0.2rem, transparent 0.21rem),
                        radial-gradient(circle, ${
                          darkMode
                            ? "rgba(17,17,17,0.85)"
                            : "rgba(17,24,39,0.8)"
                        } 0.2rem, transparent 0.21rem),
                        linear-gradient(${
                          darkMode
                            ? "rgba(255,255,255,0.3)"
                            : "rgba(0,0,0,0.25)"
                        } 0 0);
                      background-position:
                        0% 50%, 33.333% 50%, 66.666% 50%, 100% 50%, center;
                      background-size:
                        12px 12px, 12px 12px, 12px 12px, 12px 12px, 100% 3px;
                      background-repeat: no-repeat;
                    }
                    input[type="range"].appearance-none::-webkit-slider-runnable-track { height: 3px; background: transparent; }
                    input[type="range"].appearance-none::-moz-range-track { height: 3px; background: transparent; }
                    input[type="range"].appearance-none::-webkit-slider-runnable-track { height: 2px; background: transparent; }
                    input[type="range"].appearance-none::-moz-range-track { height: 2px; background: transparent; }
                    input[type="range"].appearance-none::-webkit-slider-thumb { -webkit-appearance: none; appearance: none; width: 18px; height: 18px; border-radius: 9999px; background-image: linear-gradient(90deg, #ec4899, #ef4444); border: 2px solid ${
                      darkMode ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.25)"
                    }; box-shadow: 0 0 0 2px ${
                    darkMode ? "rgba(255,255,255,0.1)" : "rgba(17,24,39,0.05)"
                  }; margin-top: -8px; position: relative; z-index: 2; }
                    input[type="range"].appearance-none::-moz-range-thumb { width: 18px; height: 18px; border-radius: 9999px; background-image: linear-gradient(90deg, #ec4899, #ef4444); border: 2px solid ${
                      darkMode ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.25)"
                    }; box-shadow: 0 0 0 2px ${
                    darkMode ? "rgba(255,255,255,0.1)" : "rgba(17,24,39,0.05)"
                  }; position: relative; z-index: 2; }
                  `}</style>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showParticipantStatsModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowParticipantStatsModal(false)}
          />
          <div
            className={`${
              darkMode
                ? "bg-gradient-to-br from-[#12121d] to-[#1e1e2f] border border-white/10"
                : "bg-white border border-gray-200/60"
            } relative w-full max-w-2xl rounded-2xl overflow-hidden`}
          >
            <button
              onClick={() => setShowParticipantStatsModal(false)}
              className={`absolute top-3 right-3 p-2 rounded-lg ${
                darkMode
                  ? "hover:bg-white/10 text-white/70 hover:text-white"
                  : "hover:bg-gray-100 text-gray-600 hover:text-gray-900"
              }`}
              aria-label="Close"
              title="Close"
            >
              <X size={18} />
            </button>
            <div
              className={`px-6 py-5 border-b ${
                darkMode ? "border-white/10" : "border-gray-200/60"
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-r from-pink-500 to-red-500">
                  <BarChart2 size={18} className="text-white" />
                </div>
                <div>
                  <h3 className="text-base font-semibold">
                    Participant Analytics
                  </h3>
                  <p
                    className={`${
                      darkMode ? "text-white/60" : "text-gray-600"
                    } text-xs`}
                  >
                    Gain insights into participant activity
                  </p>
                </div>
              </div>
            </div>
            <div className="px-6 py-5 space-y-4">
              <div className="flex">
                <div className="w-full rounded-xl p-[2px] overflow-hidden transition-colors bg-gradient-to-r from-pink-500/30 to-red-500/30 focus-within:from-pink-500 focus-within:to-red-500">
                  <div
                    className={`${
                      darkMode ? "bg-[#151528]" : "bg-white"
                    } rounded-[10px]`}
                  >
                    <input
                      type="text"
                      value={participantSearch}
                      onChange={(e) => setParticipantSearch(e.target.value)}
                      placeholder="Search participants..."
                      className={`w-full px-4 py-2 rounded-xl text-sm outline-none border-none bg-transparent focus:ring-0 focus:ring-offset-0 focus:border-transparent focus:outline-none focus-visible:outline-none ${
                        darkMode
                          ? "text-white placeholder-white/40"
                          : "text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>
                </div>
              </div>
              <div
                className={`rounded-2xl border overflow-hidden ${
                  darkMode ? "border-white/10" : "border-gray-200"
                }`}
              >
                <div
                  className={`grid grid-cols-2 px-4 py-2 text-xs font-semibold ${
                    darkMode
                      ? "bg-white/5 text-white/70"
                      : "bg-gray-50 text-gray-700"
                  }`}
                >
                  <div>Name</div>
                  <div className="text-right">Speaker Time</div>
                </div>
                <div className="divide-y divide-gray-200/50 dark:divide-white/10">
                  {participants
                    .filter((p) =>
                      p.name
                        .toLowerCase()
                        .includes(participantSearch.toLowerCase())
                    )
                    .map((p) => (
                      <div
                        key={p.id}
                        className="grid grid-cols-2 px-4 py-3 text-sm"
                      >
                        <div className="flex items-center gap-2">
                          <img
                            src={p.avatar}
                            alt={p.name}
                            className="w-7 h-7 rounded-full"
                          />
                          <span>{p.name}</span>
                        </div>
                        <div className="text-right tabular-nums">
                          {Math.floor(Math.random() * 20) + 1}m
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showBreakoutRoomsModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowBreakoutRoomsModal(false)}
          />
          <div
            className={`${
              darkMode
                ? "bg-gradient-to-br from-[#12121d] to-[#1e1e2f] border border-white/10"
                : "bg-white border border-gray-200/60"
            } relative shrink-0 w-[56rem] min-w-[56rem] max-w-none min-h-[32rem] rounded-2xl overflow-hidden`}
          >
            <button
              onClick={() => setShowBreakoutRoomsModal(false)}
              className={`${
                darkMode
                  ? "hover:bg-white/10 text-white/70 hover:text-white"
                  : "hover:bg-gray-100 text-gray-600 hover:text-gray-900"
              } absolute top-3 right-3 p-2 rounded-lg`}
              aria-label="Close"
              title="Close"
            >
              <X size={18} />
            </button>

            <div
              className={`px-6 py-5 border-b ${
                darkMode ? "border-white/10" : "border-gray-200/60"
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-r from-pink-500 to-red-500">
                  <Layout size={18} className="text-white" />
                </div>
                <div>
                  <h3 className="text-base font-semibold">
                    Manage Breakout Rooms
                  </h3>
                  <p
                    className={`${
                      darkMode ? "text-white/60" : "text-gray-600"
                    } text-xs`}
                  >
                    Create rooms and organize participants into focused groups
                  </p>
                </div>
              </div>
            </div>

            <style>{`
              .breakout-scroll { scrollbar-width: thin; scrollbar-color: ${
                darkMode
                  ? "rgba(255,255,255,0.35) transparent"
                  : "rgba(17,24,39,0.35) transparent"
              }; }
              .breakout-scroll::-webkit-scrollbar { width: 8px; height: 8px; }
              .breakout-scroll::-webkit-scrollbar-track { background: ${
                darkMode ? "rgba(255,255,255,0.05)" : "rgba(17,24,39,0.05)"
              }; border-radius: 8px; }
              .breakout-scroll::-webkit-scrollbar-thumb { background: ${
                darkMode ? "rgba(255,255,255,0.25)" : "rgba(17,24,39,0.25)"
              }; border-radius: 8px; border: 1px solid ${
              darkMode ? "rgba(255,255,255,0.18)" : "rgba(17,24,39,0.12)"
            }; }
              .breakout-scroll::-webkit-scrollbar-thumb:hover { background: ${
                darkMode ? "rgba(255,255,255,0.35)" : "rgba(17,24,39,0.35)"
              }; }
            `}</style>

            <div className="px-6 py-5 grid grid-cols-1 md:grid-cols-3 gap-5">
              <div
                className={`${
                  darkMode ? "bg-white/5" : "bg-gray-50"
                } rounded-xl p-4 md:col-span-1`}
              >
                <div className="flex items-center justify-between mb-3">
                  <h4 className="text-sm font-semibold">Rooms</h4>
                  <button
                    onClick={handleCreateBreakoutRoom}
                    className={`${
                      darkMode
                        ? "bg-white/10 hover:bg-white/15 text-white"
                        : "bg-gray-200 hover:bg-gray-300 text-gray-900"
                    } inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs`}
                  >
                    <Plus size={12} />
                    New Room
                  </button>
                </div>
                <div className="space-y-2">
                  {breakoutRooms.map((room) => (
                    <button
                      key={room.id}
                      onClick={() => handleSelectBreakoutRoom(room.id)}
                      className={`${
                        darkMode ? "hover:bg-white/10" : "hover:bg-white"
                      } w-full text-left rounded-lg p-2 flex items-center justify-between border ${
                        selectedBreakoutRoomId === room.id
                          ? darkMode
                            ? "border-pink-500/40"
                            : "border-pink-500/40"
                          : darkMode
                          ? "border-transparent"
                          : "border-transparent"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <Layout
                          size={14}
                          className={
                            darkMode ? "text-white/70" : "text-gray-700"
                          }
                        />
                        {editingRoomId === room.id ? (
                          <div
                            className="rounded-[6px] p-[1.5px]"
                            style={{
                              background:
                                "linear-gradient(90deg, rgba(236,72,153,0.9), rgba(239,68,68,0.9))",
                            }}
                          >
                            <input
                              value={editingRoomName}
                              onChange={(e) =>
                                setEditingRoomName(e.target.value)
                              }
                              onBlur={saveEditRoomName}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") saveEditRoomName();
                                if (e.key === "Escape") cancelEditRoomName();
                              }}
                              autoFocus
                              className={`${
                                darkMode
                                  ? "bg-[#0f1020] text-white"
                                  : "bg-white text-gray-900"
                              } w-28 rounded-[5px] px-2 py-0.5 text-sm appearance-none outline-none border-0 border-transparent focus:appearance-none focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-transparent focus-visible:outline-none shadow-none`}
                            />
                          </div>
                        ) : (
                          <span className="text-sm">{room.name}</span>
                        )}
                      </div>
                      <div className="flex items-center gap-2">
                        <span
                          className={`${
                            darkMode ? "text-white/50" : "text-gray-500"
                          } text-xs`}
                        >
                          {room.participantIds.length}
                        </span>
                        {editingRoomId === room.id ? (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              saveEditRoomName();
                            }}
                            className={`${
                              darkMode
                                ? "hover:bg-white/10 text-white/80"
                                : "hover:bg-gray-100 text-gray-700"
                            } p-1 rounded-md`}
                            aria-label="Save room name"
                            title="Save"
                          >
                            <CheckCircle size={14} />
                          </button>
                        ) : (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              startEditRoomName(room.id, room.name);
                            }}
                            className={`${
                              darkMode
                                ? "hover:bg-white/10 text-white/60 hover:text-white"
                                : "hover:bg-gray-100 text-gray-500 hover:text-gray-900"
                            } p-1 rounded-md`}
                            aria-label="Rename room"
                            title="Rename"
                          >
                            <Edit2 size={14} />
                          </button>
                        )}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteBreakoutRoom(room.id);
                          }}
                          className={`${
                            darkMode
                              ? "hover:bg-white/10 text-white/60 hover:text-white"
                              : "hover:bg-gray-100 text-gray-500 hover:text-gray-900"
                          } p-1 rounded-md`}
                          aria-label="Delete room"
                        >
                          <Trash2 size={14} />
                        </button>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              <div className="md:col-span-2">
                <div
                  className={`${
                    darkMode ? "bg-white/5" : "bg-gray-50"
                  } rounded-xl p-4`}
                >
                  <div className="flex items-center gap-2 mb-3">
                    <Users
                      size={16}
                      className={darkMode ? "text-white/70" : "text-gray-700"}
                    />
                    <h4 className="text-sm font-semibold">Participants</h4>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <div className="text-xs font-semibold mb-2 opacity-70">
                        Unassigned
                      </div>
                      <div className="space-y-2 max-h-64 overflow-y-auto breakout-scroll">
                        {participants.filter(
                          (p) => !assignedParticipantIds.has(p.id)
                        ).length === 0 ? (
                          <div
                            className={`${
                              darkMode ? "text-white/60" : "text-gray-600"
                            } text-sm`}
                          >
                            Everyone is assigned.
                          </div>
                        ) : (
                          participants
                            .filter((p) => !assignedParticipantIds.has(p.id))
                            .map((p) => (
                              <div
                                key={p.id}
                                className={`${
                                  darkMode
                                    ? "hover:bg-white/10"
                                    : "hover:bg-gray-100"
                                } rounded-lg p-2 flex items-center justify-between`}
                              >
                                <div className="flex items-center gap-2">
                                  <img
                                    src={p.avatar}
                                    alt={p.name}
                                    className="w-6 h-6 rounded-full"
                                  />
                                  <span className="text-sm">{p.name}</span>
                                </div>
                                <button
                                  onClick={() =>
                                    handleAssignToSelectedRoom(p.id)
                                  }
                                  disabled={!selectedBreakoutRoomId}
                                  className={`${
                                    darkMode
                                      ? "bg-white/10 hover:bg-white/15 text-white disabled:opacity-50"
                                      : "bg-gray-200 hover:bg-gray-300 text-gray-900 disabled:opacity-50"
                                  } p-1 rounded-md`}
                                  aria-label="Add to room"
                                  title="Add to room"
                                >
                                  <Plus size={14} />
                                </button>
                              </div>
                            ))
                        )}
                      </div>
                    </div>

                    <div>
                      <div className="text-xs font-semibold mb-2 opacity-70">
                        {selectedBreakoutRoom
                          ? `${selectedBreakoutRoom.name}`
                          : "No room selected"}
                      </div>
                      <div className="space-y-2 max-h-64 overflow-y-auto breakout-scroll">
                        {selectedBreakoutRoom ? (
                          participants.filter((p) =>
                            selectedBreakoutRoom.participantIds.includes(p.id)
                          ).length === 0 ? (
                            <div
                              className={`${
                                darkMode ? "text-white/60" : "text-gray-600"
                              } text-sm`}
                            >
                              No participants in this room.
                            </div>
                          ) : (
                            participants
                              .filter((p) =>
                                selectedBreakoutRoom.participantIds.includes(
                                  p.id
                                )
                              )
                              .map((p) => (
                                <div
                                  key={p.id}
                                  className={`${
                                    darkMode
                                      ? "hover:bg-white/10"
                                      : "hover:bg-gray-100"
                                  } rounded-lg p-2 flex items-center justify-between`}
                                >
                                  <div className="flex items-center gap-2">
                                    <img
                                      src={p.avatar}
                                      alt={p.name}
                                      className="w-6 h-6 rounded-full"
                                    />
                                    <span className="text-sm">{p.name}</span>
                                  </div>
                                  <button
                                    onClick={() =>
                                      handleRemoveFromRoom(
                                        selectedBreakoutRoom.id,
                                        p.id
                                      )
                                    }
                                    className={`${
                                      darkMode
                                        ? "hover:bg-white/10 text-white/60 hover:text-white"
                                        : "hover:bg-gray-200 text-gray-600 hover:text-gray-900"
                                    } p-1 rounded-md`}
                                    aria-label="Remove from room"
                                  >
                                    <Trash2 size={14} />
                                  </button>
                                </div>
                              ))
                          )
                        ) : (
                          <div
                            className={`${
                              darkMode ? "text-white/60" : "text-gray-600"
                            } text-sm`}
                          >
                            Select a room to manage assignments.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`px-6 py-4 border-t ${
                darkMode ? "border-white/10" : "border-gray-200/60"
              } flex items-center justify-between gap-2`}
            >
              <div>
                <button
                  onClick={() => setShowBreakoutRoomsModal(false)}
                  className={`${
                    darkMode
                      ? "bg-white/10 hover:bg-white/15 text-white"
                      : "bg-gray-100 hover:bg-gray-200 text-gray-900"
                  } px-4 py-2 rounded-lg text-sm font-medium`}
                >
                  Close
                </button>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={handleJoinSelectedBreakoutRoom}
                  disabled={!canJoinSelectedRoom}
                  className={`${
                    darkMode
                      ? "bg-white/10 text-white"
                      : "bg-gray-100 text-gray-900"
                  } px-4 py-2 rounded-lg text-sm font-medium disabled:opacity-60 disabled:cursor-not-allowed hover:bg-gradient-to-r hover:from-pink-500 hover:to-red-500 hover:text-white transition-colors`}
                >
                  Join Room
                </button>
                <button
                  onClick={handleToggleBreakoutRooms}
                  disabled={!canToggleBreakoutRooms}
                  className={`${
                    darkMode
                      ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                      : "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                  } px-4 py-2 rounded-lg text-sm font-medium disabled:opacity-60 disabled:cursor-not-allowed`}
                >
                  {breakoutRoomsOpen ? "Close Rooms" : "Open Rooms"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSettingsModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowSettingsModal(false)}
          />
          <div
            className={`${
              darkMode
                ? "bg-gradient-to-br from-[#12121d] to-[#1e1e2f] border border-white/10"
                : "bg-white border border-gray-200/60"
            } relative w-full max-w-4xl rounded-2xl overflow-hidden`}
          >
            <button
              onClick={() => setShowSettingsModal(false)}
              className={`absolute top-3 right-3 p-2 rounded-lg ${
                darkMode
                  ? "hover:bg-white/10 text-white/70 hover:text-white"
                  : "hover:bg-gray-100 text-gray-600 hover:text-gray-900"
              }`}
              aria-label="Close"
              title="Close"
            >
              <X size={18} />
            </button>
            <div className="grid grid-cols-[220px_1fr] min-h-[520px]">
              {/* Sidebar Tabs */}
              <div
                className={`${
                  darkMode
                    ? "bg-white/5 border-r border-white/10"
                    : "bg-gray-50 border-r border-gray-200"
                } p-4`}
              >
                {(
                  [
                    "Audio",
                    "Video",
                    "Notifications",
                    "Profile",
                    "Shortcuts",
                    "General",
                  ] as const
                ).map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setSettingsTab(tab)}
                    className={`w-full text-left px-3 py-2 rounded-lg mb-2 text-sm font-medium transition-colors ${
                      settingsTab === tab
                        ? darkMode
                          ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                          : "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                        : darkMode
                        ? "hover:bg-white/10 text-white/80"
                        : "hover:bg-gray-100 text-gray-800"
                    }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
              {/* Content */}
              <div className="p-6 space-y-4">
                {settingsTab === "Audio" && (
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold mb-3">Audio</h3>
                      <p
                        className={`${
                          darkMode ? "text-white/60" : "text-gray-600"
                        } text-sm`}
                      >
                        Configure microphone, speaker, and advanced audio
                        options.
                      </p>
                    </div>

                    {/* Microphone Section */}
                    <div className="space-y-4">
                      <div>
                        <h4
                          className={`text-sm font-semibold mb-2 ${
                            darkMode ? "text-white" : "text-gray-900"
                          }`}
                        >
                          Microphone
                        </h4>
                        <div className="space-y-3">
                          {/* Microphone Dropdown */}
                          <div className="relative">
                            <select
                              value={selectedMicrophone}
                              onChange={(e) =>
                                handleMicrophoneSelect(e.target.value)
                              }
                              className={`w-full px-3 py-2 rounded-lg text-sm outline-none border transition-all duration-200 focus:ring-2 focus:ring-pink-500/50 focus:border-transparent ${
                                darkMode
                                  ? "bg-white/5 border-white/10 text-white"
                                  : "bg-gray-50/80 border-gray-200 text-gray-900"
                              }`}
                            >
                              {mockAudioDevices.microphones.map((mic) => (
                                <option
                                  key={mic.id}
                                  value={mic.name}
                                  className={
                                    darkMode
                                      ? "bg-gray-800 text-white"
                                      : "bg-white text-gray-900"
                                  }
                                >
                                  {mic.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Live Audio Test Bar */}
                          <div className="space-y-2">
                            <div
                              className={`text-xs ${
                                darkMode ? "text-white/70" : "text-gray-600"
                              }`}
                            >
                              Live audio test
                            </div>
                            <div
                              className={`w-full h-2 rounded-full ${
                                darkMode ? "bg-white/10" : "bg-gray-200"
                              }`}
                            >
                              <div
                                className="h-full rounded-full bg-gradient-to-r from-pink-500 to-red-500 transition-all duration-300"
                                style={{ width: `${Math.random() * 60 + 20}%` }}
                              ></div>
                            </div>
                            <div
                              className={`text-xs ${
                                darkMode ? "text-white/50" : "text-gray-500"
                              }`}
                            >
                              Audio level: {Math.floor(Math.random() * 40 + 30)}
                              %
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Audio Output Section */}
                      <div>
                        <h4
                          className={`text-sm font-semibold mb-2 ${
                            darkMode ? "text-white" : "text-gray-900"
                          }`}
                        >
                          Audio Output
                        </h4>
                        <div className="space-y-3">
                          {/* Speaker Dropdown */}
                          <div className="relative">
                            <select
                              value={selectedSpeaker}
                              onChange={(e) =>
                                handleSpeakerSelect(e.target.value)
                              }
                              className={`w-full px-3 py-2 rounded-lg text-sm outline-none border transition-all duration-200 focus:ring-2 focus:ring-pink-500/50 focus:border-transparent ${
                                darkMode
                                  ? "bg-white/5 border-white/10 text-white"
                                  : "bg-gray-50/80 border-gray-200 text-gray-900"
                              }`}
                            >
                              {mockAudioDevices.speakers.map((speaker) => (
                                <option
                                  key={speaker.id}
                                  value={speaker.name}
                                  className={
                                    darkMode
                                      ? "bg-gray-800 text-white"
                                      : "bg-white text-gray-900"
                                  }
                                >
                                  {speaker.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Test Button */}
                          <button
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                              darkMode
                                ? "bg-white/10 hover:bg-white/20 text-white"
                                : "bg-gray-100 hover:bg-gray-200 text-gray-900"
                            }`}
                          >
                            Test Audio Output
                          </button>
                        </div>
                      </div>

                      {/* Noise Suppression */}
                      <div>
                        <h4
                          className={`text-sm font-semibold mb-2 ${
                            darkMode ? "text-white" : "text-gray-900"
                          }`}
                        >
                          Advanced
                        </h4>
                        <label className="flex items-center gap-3 text-sm cursor-pointer select-none">
                          <input
                            type="checkbox"
                            checked={enableNoiseSuppression}
                            onChange={(e) =>
                              setEnableNoiseSuppression(e.target.checked)
                            }
                            className="h-4 w-4 rounded border-gray-300 text-pink-500 focus:ring-0 focus:outline-none"
                          />
                          <span
                            className={
                              darkMode ? "text-white/90" : "text-gray-900"
                            }
                          >
                            Noise suppression
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                )}
                {settingsTab === "Video" && (
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold mb-3">Video</h3>
                      <p
                        className={`${
                          darkMode ? "text-white/60" : "text-gray-600"
                        } text-sm`}
                      >
                        Select camera, resolution, and layout preferences.
                      </p>
                    </div>

                    {/* Camera Preview */}
                    <div>
                      <h4
                        className={`text-sm font-semibold mb-2 ${
                          darkMode ? "text-white" : "text-gray-900"
                        }`}
                      >
                        Camera Preview
                      </h4>
                      <div
                        className={`rounded-lg overflow-hidden ${
                          darkMode ? "bg-gray-800" : "bg-gray-200"
                        } h-48 flex items-center justify-center`}
                      >
                        <div className="w-full h-full flex items-center justify-center">
                          <div
                            className={`w-20 h-20 rounded-full flex items-center justify-center ${
                              darkMode ? "bg-gray-700" : "bg-gray-300"
                            }`}
                          >
                            <Camera
                              size={24}
                              className={
                                darkMode ? "text-white/60" : "text-gray-600"
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Camera Settings */}
                    <div className="space-y-4">
                      <div>
                        <h4
                          className={`text-sm font-semibold mb-2 ${
                            darkMode ? "text-white" : "text-gray-900"
                          }`}
                        >
                          Camera
                        </h4>
                        <div className="space-y-3">
                          {/* Camera Dropdown */}
                          <div className="relative">
                            <select
                              value={selectedCamera}
                              onChange={(e) =>
                                handleCameraSelect(e.target.value)
                              }
                              className={`w-full px-3 py-2 rounded-lg text-sm outline-none border transition-all duration-200 focus:ring-2 focus:ring-pink-500/50 focus:border-transparent ${
                                darkMode
                                  ? "bg-white/5 border-white/10 text-white"
                                  : "bg-gray-50/80 border-gray-200 text-gray-900"
                              }`}
                            >
                              {mockAudioDevices.cameras.map((cam) => (
                                <option
                                  key={cam.id}
                                  value={cam.name}
                                  className={
                                    darkMode
                                      ? "bg-gray-800 text-white"
                                      : "bg-white text-gray-900"
                                  }
                                >
                                  {cam.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Mirror Video Checkbox */}
                          <label className="flex items-center gap-3 text-sm cursor-pointer select-none">
                            <input
                              type="checkbox"
                              checked={mirrorVideo}
                              onChange={(e) => setMirrorVideo(e.target.checked)}
                              className="h-4 w-4 rounded border-gray-300 text-pink-500 focus:ring-0 focus:outline-none"
                            />
                            <span
                              className={
                                darkMode ? "text-white/90" : "text-gray-900"
                              }
                            >
                              Mirror my video
                            </span>
                          </label>
                        </div>
                      </div>

                      {/* Desktop Sharing Settings */}
                      <div>
                        <h4
                          className={`text-sm font-semibold mb-2 ${
                            darkMode ? "text-white" : "text-gray-900"
                          }`}
                        >
                          Desktop Sharing
                        </h4>
                        <div className="space-y-3">
                          {/* Framerate Dropdown */}
                          <div>
                            <label
                              className={`text-xs ${
                                darkMode ? "text-white/70" : "text-gray-600"
                              } mb-1 block`}
                            >
                              Framerate
                            </label>
                            <div className="relative">
                              <select
                                className={`w-full px-3 py-2 rounded-lg text-sm outline-none border transition-all duration-200 focus:ring-2 focus:ring-pink-500/50 focus:border-transparent ${
                                  darkMode
                                    ? "bg-white/5 border-white/10 text-white"
                                    : "bg-gray-50/80 border-gray-200 text-gray-900"
                                }`}
                              >
                                <option
                                  value="5"
                                  className={
                                    darkMode
                                      ? "bg-gray-800 text-white"
                                      : "bg-white text-gray-900"
                                  }
                                >
                                  5 frames-per-second
                                </option>
                                <option
                                  value="10"
                                  className={
                                    darkMode
                                      ? "bg-gray-800 text-white"
                                      : "bg-white text-gray-900"
                                  }
                                >
                                  10 frames-per-second
                                </option>
                                <option
                                  value="15"
                                  className={
                                    darkMode
                                      ? "bg-gray-800 text-white"
                                      : "bg-white text-gray-900"
                                  }
                                >
                                  15 frames-per-second
                                </option>
                              </select>
                            </div>
                            <div
                              className={`text-xs mt-2 ${
                                darkMode ? "text-white/50" : "text-gray-500"
                              }`}
                            >
                              You need to restart the screen share for the new
                              settings to take effect.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {settingsTab === "Notifications" && (
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold mb-3">
                        Notifications
                      </h3>
                      <p
                        className={`${
                          darkMode ? "text-white/60" : "text-gray-600"
                        } text-sm`}
                      >
                        Control system notifications and sounds.
                      </p>
                    </div>

                    {/* Play Sound On Section */}
                    <div>
                      <h4
                        className={`text-sm font-semibold mb-3 ${
                          darkMode ? "text-white" : "text-gray-900"
                        }`}
                      >
                        Play sound on:
                      </h4>
                      <div className="space-y-3">
                        {[
                          "Meeting Reactions",
                          "Incoming Message",
                          "Participant Joined",
                          "Participant Left",
                          "Talk While Muted",
                          "Participant Entered Lobby",
                        ].map((notification) => (
                          <label
                            key={notification}
                            className="flex items-center gap-3 text-sm cursor-pointer select-none"
                          >
                            <input
                              type="checkbox"
                              defaultChecked={true}
                              className="h-4 w-4 rounded border-gray-300 text-pink-500 focus:ring-0 focus:outline-none"
                            />
                            <span
                              className={
                                darkMode ? "text-white/90" : "text-gray-900"
                              }
                            >
                              {notification}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {settingsTab === "Profile" && (
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold mb-3">Profile</h3>
                      <p
                        className={`${
                          darkMode ? "text-white/60" : "text-gray-600"
                        } text-sm`}
                      >
                        Update your profile details and preferences.
                      </p>
                    </div>

                    {/* Profile Image */}
                    <div>
                      <h4
                        className={`text-sm font-semibold mb-3 ${
                          darkMode ? "text-white" : "text-gray-900"
                        }`}
                      >
                        Profile Image
                      </h4>
                      <div className="flex items-center gap-4">
                        <div className="relative">
                          <img
                            src="https://randomuser.me/api/portraits/women/44.jpg"
                            alt="Profile"
                            className="w-16 h-16 rounded-full border-2 border-gray-200"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Name */}
                    <div>
                      <h4
                        className={`text-sm font-semibold mb-2 ${
                          darkMode ? "text-white" : "text-gray-900"
                        }`}
                      >
                        Name
                      </h4>
                      <input
                        type="text"
                        defaultValue="Ledy Sintia"
                        className={`w-full px-3 py-2 rounded-lg text-sm outline-none border transition-all duration-200 focus:ring-2 focus:ring-pink-500/50 focus:border-transparent ${
                          darkMode
                            ? "bg-white/5 border-white/10 text-white placeholder-white/40"
                            : "bg-gray-50/80 border-gray-200 text-gray-900 placeholder-gray-500"
                        }`}
                        placeholder="Enter your name"
                      />
                    </div>

                    {/* Logged In As */}
                    <div>
                      <h4
                        className={`text-sm font-semibold mb-2 ${
                          darkMode ? "text-white" : "text-gray-900"
                        }`}
                      >
                        Logged in as
                      </h4>
                      <div
                        className={`px-3 py-2 rounded-lg text-sm ${
                          darkMode
                            ? "bg-white/5 text-white/70"
                            : "bg-gray-50/80 text-gray-600"
                        }`}
                      >
                        ledy.sintia@email.com
                      </div>
                    </div>
                  </div>
                )}
                {settingsTab === "Shortcuts" && (
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold mb-3">Shortcuts</h3>
                      <p
                        className={`${
                          darkMode ? "text-white/60" : "text-gray-600"
                        } text-sm`}
                      >
                        Configure keyboard shortcuts for quick actions.
                      </p>
                    </div>

                    {/* Enable Keyboard Shortcuts */}
                    <div>
                      <label className="flex items-center gap-3 text-sm cursor-pointer select-none">
                        <input
                          type="checkbox"
                          defaultChecked={true}
                          className="h-4 w-4 rounded border-gray-300 text-pink-500 focus:ring-0 focus:outline-none"
                        />
                        <span
                          className={
                            darkMode ? "text-white/90" : "text-gray-900"
                          }
                        >
                          Enable keyboard shortcuts
                        </span>
                      </label>
                    </div>

                    {/* Shortcuts List */}
                    <div className="space-y-3 max-h-96 overflow-y-auto pr-2">
                      {[
                        { action: "Show or hide video thumbnails", key: "F" },
                        { action: "Mute or unmute your microphone", key: "M" },
                        { action: "Start or stop camera", key: "V" },
                        { action: "Manage video quality", key: "A" },
                        { action: "Open or close the chat", key: "C" },
                        {
                          action: "Switch between camera and screen sharing",
                          key: "D",
                        },
                        {
                          action: "Show or hide the participants pane",
                          key: "P",
                        },
                        { action: "Raise or lower your hand", key: "R" },
                        { action: "View or exit full screen", key: "S" },
                        { action: "Toggle tile view", key: "W" },
                        { action: "Show participants stats", key: "T" },
                        { action: "Send thumbs up reaction", key: "⌥ + T" },
                        { action: "Send clap reaction", key: "⌥ + C" },
                        { action: "Send laugh reaction", key: "⌥ + L" },
                        { action: "Send surprised reaction", key: "⌥ + O" },
                        { action: "Send boo reaction", key: "⌥ + B" },
                        { action: "Send silence reaction", key: "⌥ + S" },
                        { action: "Show or hide keyboard shortcuts", key: "?" },
                        { action: "Push to talk", key: "Space" },
                        { action: "Focus on your video", key: "0" },
                        {
                          action: "Focus on another person's video",
                          key: "1-9",
                        },
                      ].map((shortcut, index) => (
                        <div
                          key={index}
                          className={`flex items-center justify-between p-3 rounded-lg ${
                            darkMode ? "bg-white/5" : "bg-gray-50/80"
                          }`}
                        >
                          <span
                            className={`text-sm ${
                              darkMode ? "text-white/90" : "text-gray-900"
                            }`}
                          >
                            {shortcut.action}
                          </span>
                          <div
                            className={`px-2 py-1 rounded text-xs font-medium ${
                              darkMode
                                ? "bg-white/10 text-white/80"
                                : "bg-gray-200 text-gray-700"
                            }`}
                          >
                            {shortcut.key}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {settingsTab === "General" && (
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold mb-3">General</h3>
                      <p
                        className={`${
                          darkMode ? "text-white/60" : "text-gray-600"
                        } text-sm`}
                      >
                        General application settings.
                      </p>
                    </div>

                    {/* Enable Pre-meeting Screen */}
                    <div>
                      <label className="flex items-center gap-3 text-sm cursor-pointer select-none">
                        <input
                          type="checkbox"
                          defaultChecked={true}
                          className="h-4 w-4 rounded border-gray-300 text-pink-500 focus:ring-0 focus:outline-none"
                        />
                        <span
                          className={
                            darkMode ? "text-white/90" : "text-gray-900"
                          }
                        >
                          Enable pre-meeting screen
                        </span>
                      </label>
                    </div>

                    {/* Language */}
                    <div>
                      <h4
                        className={`text-sm font-semibold mb-2 ${
                          darkMode ? "text-white" : "text-gray-900"
                        }`}
                      >
                        Language
                      </h4>
                      <div className="relative">
                        <select
                          className={`w-full px-3 py-2 rounded-lg text-sm outline-none border transition-all duration-200 focus:ring-2 focus:ring-pink-500/50 focus:border-transparent ${
                            darkMode
                              ? "bg-white/5 border-white/10 text-white"
                              : "bg-gray-50/80 border-gray-200 text-gray-900"
                          }`}
                        >
                          <option
                            value="en"
                            className={
                              darkMode
                                ? "bg-gray-800 text-white"
                                : "bg-white text-gray-900"
                            }
                          >
                            English
                          </option>
                          <option
                            value="es"
                            className={
                              darkMode
                                ? "bg-gray-800 text-white"
                                : "bg-white text-gray-900"
                            }
                          >
                            Español
                          </option>
                          <option
                            value="fr"
                            className={
                              darkMode
                                ? "bg-gray-800 text-white"
                                : "bg-white text-gray-900"
                            }
                          >
                            Français
                          </option>
                          <option
                            value="de"
                            className={
                              darkMode
                                ? "bg-gray-800 text-white"
                                : "bg-white text-gray-900"
                            }
                          >
                            Deutsch
                          </option>
                          <option
                            value="it"
                            className={
                              darkMode
                                ? "bg-gray-800 text-white"
                                : "bg-white text-gray-900"
                            }
                          >
                            Italiano
                          </option>
                          <option
                            value="pt"
                            className={
                              darkMode
                                ? "bg-gray-800 text-white"
                                : "bg-white text-gray-900"
                            }
                          >
                            Português
                          </option>
                          <option
                            value="ru"
                            className={
                              darkMode
                                ? "bg-gray-800 text-white"
                                : "bg-white text-gray-900"
                            }
                          >
                            Русский
                          </option>
                          <option
                            value="zh"
                            className={
                              darkMode
                                ? "bg-gray-800 text-white"
                                : "bg-white text-gray-900"
                            }
                          >
                            中文
                          </option>
                          <option
                            value="ja"
                            className={
                              darkMode
                                ? "bg-gray-800 text-white"
                                : "bg-white text-gray-900"
                            }
                          >
                            日本語
                          </option>
                          <option
                            value="ko"
                            className={
                              darkMode
                                ? "bg-gray-800 text-white"
                                : "bg-white text-gray-900"
                            }
                          >
                            한국어
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Notifications Modal */}
      {showNotificationsModal && (
        <div
          className={`fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm ${
            darkMode ? "bg-black/60" : "bg-gray-900/40"
          }`}
        >
          <div
            className={`rounded-2xl shadow-2xl p-8 md:p-12 w-[90vw] max-w-4xl relative max-h-[90vh] overflow-y-auto scrollbar-hide ${
              darkMode ? "bg-[#232336]" : "bg-white"
            }`}
          >
            <button
              className={`absolute top-6 right-6 transition-colors duration-200 ${
                darkMode
                  ? "text-white/60 hover:text-white"
                  : "text-gray-600 hover:text-gray-900"
              }`}
              onClick={() => setShowNotificationsModal(false)}
            >
              <X size={28} />
            </button>

            {/* Header */}
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-1 h-6 bg-gradient-to-b from-pink-600 to-red-500 rounded-full"></div>
                <h2
                  className={`text-3xl font-bold ${
                    darkMode ? "text-white" : "text-gray-900"
                  }`}
                >
                  Notifications
                </h2>
              </div>
            </div>

            {/* Tab Navigation */}
            <div
              className={`flex gap-1 mb-8 rounded-xl p-1 ${
                darkMode ? "bg-white/5" : "bg-gray-100"
              }`}
            >
              <button
                className={`flex-1 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                  notificationsTab === "current"
                    ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                    : darkMode
                    ? "text-white/60 hover:text-white hover:bg-white/5"
                    : "text-gray-600 hover:text-gray-900 hover:bg-gray-200"
                }`}
                onClick={() => setNotificationsTab("current")}
              >
                Current ({notifications.length})
              </button>
              <button
                className={`flex-1 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                  notificationsTab === "cleared"
                    ? "bg-gradient-to-r from-pink-500 to-red-500 text-white shadow-lg"
                    : darkMode
                    ? "text-white/60 hover:text-white hover:bg-white/5"
                    : "text-gray-600 hover:text-gray-900 hover:bg-gray-200"
                }`}
                onClick={() => setNotificationsTab("cleared")}
              >
                Cleared ({clearedNotifications.length})
              </button>
            </div>

            {notificationsTab === "current" && (
              <div className="space-y-6">
                {notifications.length === 0 ? (
                  <div className="text-center py-16">
                    <div
                      className={`w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full ${
                        darkMode ? "bg-white/5" : "bg-gray-100"
                      }`}
                    >
                      <Bell
                        size={32}
                        className={`${
                          darkMode ? "text-white/40" : "text-gray-400"
                        }`}
                      />
                    </div>
                    <h3
                      className={`text-xl font-semibold mb-2 ${
                        darkMode ? "text-white" : "text-gray-900"
                      }`}
                    >
                      No notifications
                    </h3>
                    <p
                      className={`${
                        darkMode ? "text-white/60" : "text-gray-600"
                      }`}
                    >
                      You're all caught up! Check back later for updates.
                    </p>
                  </div>
                ) : (
                  <>
                    <div className="grid gap-4">
                      {notifications.map((n) => (
                        <div
                          key={n.id}
                          className={`group rounded-xl p-6 border transition-all duration-200 ${
                            darkMode
                              ? "bg-white/5 border-white/10 hover:border-white/20"
                              : "bg-gray-50 border-gray-200 hover:border-gray-300"
                          }`}
                        >
                          <div className="flex items-start gap-4">
                            <div className="flex-shrink-0 mt-1">{n.icon}</div>
                            <div className="flex-1 min-w-0">
                              <p
                                className={`text-base leading-relaxed mb-2 ${
                                  darkMode ? "text-white/90" : "text-gray-900"
                                }`}
                              >
                                {n.text}
                              </p>
                              <div
                                className={`flex items-center gap-4 text-sm ${
                                  darkMode ? "text-white/40" : "text-gray-500"
                                }`}
                              >
                                <span>Just now</span>
                                <span>•</span>
                                <span>Unread</span>
                              </div>
                            </div>
                            <button
                              className={`flex-shrink-0 p-2 rounded-lg transition-all duration-200 group-hover:opacity-100 opacity-0 ${
                                darkMode
                                  ? "hover:bg-red-600/20 text-white/60 hover:text-red-400"
                                  : "hover:bg-red-50 text-gray-600 hover:text-red-600"
                              }`}
                              onClick={() => handleClearNotification(n.id)}
                              aria-label="Clear notification"
                            >
                              <Trash2 size={18} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div
                      className={`flex justify-center pt-6 border-t ${
                        darkMode ? "border-white/10" : "border-gray-200"
                      }`}
                    >
                      <button
                        className="flex-1 bg-gradient-to-r from-red-600 to-pink-600 hover:scale-105 text-white font-semibold py-3 rounded-xl transition-all duration-200 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={handleClearAll}
                        disabled={notifications.length === 0}
                      >
                        Clear All Notifications
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}

            {notificationsTab === "cleared" && (
              <div className="space-y-6">
                {clearedNotifications.length === 0 ? (
                  <div className="text-center py-16">
                    <div
                      className={`w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full ${
                        darkMode ? "bg-white/5" : "bg-gray-100"
                      }`}
                    >
                      <Trash2
                        size={32}
                        className={`${
                          darkMode ? "text-white/40" : "text-gray-400"
                        }`}
                      />
                    </div>
                    <h3
                      className={`text-xl font-semibold mb-2 ${
                        darkMode ? "text-white" : "text-gray-900"
                      }`}
                    >
                      No cleared notifications
                    </h3>
                    <p
                      className={`${
                        darkMode ? "text-white/60" : "text-gray-600"
                      }`}
                    >
                      Notifications you clear will appear here.
                    </p>
                  </div>
                ) : (
                  <>
                    <div className="grid gap-4">
                      {clearedNotifications.map((n) => (
                        <div
                          key={n.id}
                          className={`group rounded-xl p-6 border transition-all duration-200 ${
                            darkMode
                              ? "bg-white/5 border-white/10 hover:border-white/20"
                              : "bg-gray-50 border-gray-200 hover:border-gray-300"
                          }`}
                        >
                          <div className="flex items-start gap-4">
                            <div className="flex-shrink-0 mt-1">{n.icon}</div>
                            <div className="flex-1 min-w-0">
                              <p
                                className={`text-base leading-relaxed mb-2 line-through ${
                                  darkMode ? "text-white/70" : "text-gray-600"
                                }`}
                              >
                                {n.text}
                              </p>
                              <div
                                className={`flex items-center gap-4 text-sm ${
                                  darkMode ? "text-white/30" : "text-gray-400"
                                }`}
                              >
                                <span>Cleared</span>
                                <span>•</span>
                                <span>Just now</span>
                              </div>
                            </div>
                            <button
                              className={`flex-shrink-0 p-2 rounded-lg transition-all duration-200 group-hover:opacity-100 opacity-0 ${
                                darkMode
                                  ? "hover:bg-green-600/20 text-white/60 hover:text-green-400"
                                  : "hover:bg-green-200 text-green-700 hover:text-green-900 bg-green-50"
                              }`}
                              onClick={() => handleRestoreNotification(n.id)}
                              aria-label="Restore notification"
                            >
                              <Plus size={18} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Share Video Modal */}
      {showShareVideoModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowShareVideoModal(false)}
          />
          <div
            className={`${
              darkMode
                ? "bg-gradient-to-br from-[#12121d] to-[#1e1e2f] border border-white/10"
                : "bg-white border border-gray-200/60"
            } relative w-full max-w-lg rounded-2xl overflow-hidden`}
          >
            <button
              onClick={() => setShowShareVideoModal(false)}
              className={`absolute top-3 right-3 p-2 rounded-lg ${
                darkMode
                  ? "hover:bg-white/10 text-white/70 hover:text-white"
                  : "hover:bg-gray-100 text-gray-600 hover:text-gray-900"
              }`}
              aria-label="Close"
              title="Close"
            >
              <X size={18} />
            </button>
            <div
              className={`px-6 py-5 border-b ${
                darkMode ? "border-white/10" : "border-gray-200/60"
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-r from-pink-500 to-red-500">
                  <Video size={18} className="text-white" />
                </div>
                <div>
                  <h3 className="text-base font-semibold">Share Video</h3>
                  <p
                    className={`${
                      darkMode ? "text-white/60" : "text-gray-600"
                    } text-xs`}
                  >
                    Paste a video URL to share with participants
                  </p>
                </div>
              </div>
            </div>
            <div className="px-6 py-5 space-y-4">
              <div>
                <label
                  className={`text-sm font-medium ${
                    darkMode ? "text-white/70" : "text-gray-700"
                  }`}
                >
                  Video URL
                </label>
                <div className="mt-2 w-full rounded-xl p-[2px] bg-gradient-to-r from-pink-500 to-red-500 overflow-hidden">
                  <div
                    className={`${
                      darkMode ? "bg-[#151528]" : "bg-gray-50"
                    } rounded-[10px]`}
                  >
                    <input
                      type="url"
                      value={shareVideoUrl}
                      onChange={(e) => setShareVideoUrl(e.target.value)}
                      placeholder="https://example.com/video.mp4 or https://youtu.be/..."
                      className={`w-full px-4 py-2 rounded-[10px] text-base outline-none border-none bg-transparent focus:ring-0 focus:border-transparent ${
                        darkMode
                          ? "text-white placeholder-white/40"
                          : "text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-end gap-3 pt-2">
                <button
                  onClick={() => setShowShareVideoModal(false)}
                  className={`px-4 py-2.5 rounded-xl text-sm font-medium ${
                    darkMode
                      ? "bg-white/10 hover:bg-white/15 text-white"
                      : "bg-gray-100 hover:bg-gray-200 text-gray-800"
                  }`}
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    /* TODO: implement start sharing video */ setShowShareVideoModal(
                      false
                    );
                    setIsScreenSharing(true);
                  }}
                  disabled={!shareVideoUrl.trim()}
                  className={`px-4 py-2.5 rounded-xl text-sm font-medium ${
                    shareVideoUrl.trim()
                      ? "bg-gradient-to-r from-pink-500 to-red-500 text-white hover:from-pink-600 hover:to-red-600"
                      : darkMode
                      ? "bg-white/10 text-white/50 cursor-not-allowed"
                      : "bg-gray-100 text-gray-400 cursor-not-allowed"
                  }`}
                >
                  Share
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Captions Configuration Modal */}
      {showCaptionsModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowCaptionsModal(false)}
          />
          <div
            className={`relative w-full max-w-lg rounded-2xl overflow-hidden ${
              darkMode
                ? "bg-gradient-to-br from-[#12121d] to-[#1e1e2f] border border-white/10"
                : "bg-white border border-gray-200/60"
            }`}
          >
            {/* Header */}
            <div
              className={`px-6 py-5 border-b ${
                darkMode ? "border-white/10" : "border-gray-200/60"
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3
                    className={`text-lg font-semibold ${
                      darkMode ? "text-white" : "text-gray-900"
                    }`}
                  >
                    Captions
                  </h3>
                  <p
                    className={`text-sm ${
                      darkMode ? "text-white/60" : "text-gray-600"
                    }`}
                  >
                    Enable closed captions or translate speech in real time
                  </p>
                </div>
                <button
                  onClick={() => setShowCaptionsModal(false)}
                  className={`p-2 rounded ${
                    darkMode
                      ? "hover:bg-white/10 text-white/70 hover:text-white"
                      : "hover:bg-gray-100 text-gray-600 hover:text-gray-900"
                  }`}
                  aria-label="Close"
                >
                  <X size={16} />
                </button>
              </div>
            </div>

            {/* Body */}
            <div className="px-6 py-5 space-y-5">
              <div className="flex items-center justify-between">
                <div>
                  <div
                    className={`font-medium ${
                      darkMode ? "text-white" : "text-gray-900"
                    }`}
                  >
                    Enable captions
                  </div>
                  <div
                    className={`text-sm ${
                      darkMode ? "text-white/60" : "text-gray-600"
                    }`}
                  >
                    Turn on or off captions for this meeting
                  </div>
                </div>
                <ToggleSwitch
                  checked={captionsEnabled}
                  onChange={setCaptionsEnabled}
                />
              </div>

              <div>
                <div
                  className={`text-sm font-medium mb-2 ${
                    darkMode ? "text-white/80" : "text-gray-800"
                  }`}
                >
                  Mode
                </div>
                <div className="flex gap-2">
                  <button
                    type="button"
                    onClick={() => setCaptionMode("closed")}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
                      captionMode === "closed"
                        ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                        : darkMode
                        ? "text-white/80 hover:bg-white/10"
                        : "text-gray-700 hover:bg-gray-100"
                    }`}
                  >
                    Closed captions
                  </button>
                  <button
                    type="button"
                    onClick={() => setCaptionMode("translated")}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
                      captionMode === "translated"
                        ? "bg-gradient-to-r from-pink-500 to-red-500 text-white"
                        : darkMode
                        ? "text-white/80 hover:bg-white/10"
                        : "text-gray-700 hover:bg-gray-100"
                    }`}
                  >
                    Translated captions
                  </button>
                </div>
              </div>

              {captionMode === "closed" ? (
                <div className="grid grid-cols-1 gap-3">
                  <label
                    className={`text-sm ${
                      darkMode ? "text-white/70" : "text-gray-700"
                    }`}
                  >
                    Language
                  </label>
                  <select
                    value={sourceLanguage}
                    onChange={(e) => setSourceLanguage(e.target.value)}
                    className={`px-3 py-2 rounded-lg border outline-none focus:ring-2 focus:ring-pink-500/50 ${
                      darkMode
                        ? "bg-white/5 border-white/10 text-white"
                        : "bg-white border-gray-300 text-gray-900"
                    }`}
                  >
                    {[
                      "English",
                      "Spanish",
                      "French",
                      "German",
                      "Portuguese",
                      "Italian",
                      "Chinese",
                      "Japanese",
                    ].map((lang) => (
                      <option key={lang} value={lang}>
                        {lang}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label
                      className={`text-sm ${
                        darkMode ? "text-white/70" : "text-gray-700"
                      }`}
                    >
                      From
                    </label>
                    <select
                      value={sourceLanguage}
                      onChange={(e) => setSourceLanguage(e.target.value)}
                      className={`mt-1 w-full px-3 py-2 rounded-lg border outline-none focus:ring-2 focus:ring-pink-500/50 ${
                        darkMode
                          ? "bg-white/5 border-white/10 text-white"
                          : "bg-white border-gray-300 text-gray-900"
                      }`}
                    >
                      {[
                        "English",
                        "Spanish",
                        "French",
                        "German",
                        "Portuguese",
                        "Italian",
                        "Chinese",
                        "Japanese",
                      ].map((lang) => (
                        <option key={lang} value={lang}>
                          {lang}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label
                      className={`text-sm ${
                        darkMode ? "text-white/70" : "text-gray-700"
                      }`}
                    >
                      To
                    </label>
                    <select
                      value={targetLanguage}
                      onChange={(e) => setTargetLanguage(e.target.value)}
                      className={`mt-1 w-full px-3 py-2 rounded-lg border outline-none focus:ring-2 focus:ring-pink-500/50 ${
                        darkMode
                          ? "bg-white/5 border-white/10 text-white"
                          : "bg-white border-gray-300 text-gray-900"
                      }`}
                    >
                      {[
                        "English",
                        "Spanish",
                        "French",
                        "German",
                        "Portuguese",
                        "Italian",
                        "Chinese",
                        "Japanese",
                      ].map((lang) => (
                        <option key={lang} value={lang}>
                          {lang}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </div>

            {/* Footer */}
            <div
              className={`px-6 py-4 border-t flex items-center justify-end ${
                darkMode ? "border-white/10" : "border-gray-200/60"
              }`}
            >
              <div className="flex gap-2">
                <button
                  onClick={() => setShowCaptionsModal(false)}
                  className={`px-3 py-2 text-sm rounded-lg ${
                    darkMode
                      ? "bg-white/10 hover:bg-white/15 text-white"
                      : "bg-gray-100 hover:bg-gray-200 text-gray-800"
                  }`}
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setCaptionsEnabled(true);
                    setShowCaptionsModal(false);
                  }}
                  className="px-3 py-2 text-sm rounded-lg bg-gradient-to-r from-pink-500 to-red-500 text-white hover:from-pink-600 hover:to-red-600"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MeetingNew;
